import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react"
import { Col, Container, Row } from "reactstrap"
import { ContextMenu } from "primereact/contextmenu"
import { TabView, TabPanel } from "primereact/tabview"
import { Dropdown } from "primereact/dropdown"
import { useNavigate, Link } from "react-router-dom"
import { FilterMatchMode } from "primereact/api"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import "jspdf-autotable"
import { jsPDF } from "jspdf"
import * as XLSX from "xlsx"
import { Dialog } from "primereact/dialog"
import Modal from "react-bootstrap/Modal"
import { Calendar } from "primereact/calendar"
import { Checkbox } from "primereact/checkbox"
import { InputTextarea } from "primereact/inputtextarea"
import { TreeSelect } from "primereact/treeselect"
import axios from "axios"
import { Accordion, AccordionTab } from "primereact/accordion"
import { Badge } from "primereact/badge"
import { TreeTable } from "primereact/treetable"
import { Sidebar } from "primereact/sidebar"
import moment from "moment"
import { Tooltip } from "primereact/tooltip"
import { FileUpload } from "primereact/fileupload"
import { Editor } from "primereact/editor"
import LinkJobs from "./LinkJobs"
import { Card } from "primereact/card"
import { CascadeSelect } from "primereact/cascadeselect"
import { Toast } from "primereact/toast"
import { setCandidateSidebarVisible } from "store/actions"


// import Notes from "../Common/Notes"
import NotesCandidate from "../Common/NotesCandidate"

import EmailAC from "./EmailAC"
import SubmitCandidatetoJob from "./SubmitCandidatetoJob"
import FilePreview from "./FilePreview"
import LinkContactsPopup from "ATSComponents/Common/LinkContactsPopup"
import { Controller, useForm } from "react-hook-form"
import { ProgressSpinner } from "primereact/progressspinner"
import {
  downloadFile,
  exportExcel,
  exportPdf,
  formatDateTime,
  triggerAlert,
} from "utils/CommonFunctions"
import LinkCandidate from "ATSComponents/Common/LinkCandidate"
// import TalentScan from "./TalentScan"
import { ClipLoader } from "react-spinners"
import { useDispatch, useSelector } from "react-redux"
import { setPageData } from "store/actions"
import {
  emailValidation,
  MaxLengthValidation,
  MinLengthValidation,
  onlyAlphabetsandSpaces,
  onlyNumbers,
  status,
} from "utils/Constants"
import { MultiSelect } from "primereact/multiselect"
import { menuIdData } from "../../utils/Constants"
import { get_user_menu_permission } from "../../utils/CommonFunctions"
import { FALSE } from "sass"
import { Chips } from "primereact/chips"
// import { co } from "@fullcalendar/core/internal-common"

import Swal from "sweetalert2";


export const warningAlert = (message) => {
  return Swal.fire({
    icon: "warning",
    title: "Warning",
    text: message,
    confirmButtonText: "OK",
    confirmButtonColor: "#f59e0b", // amber/yellow button
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
};

const AllActiveemp = forwardRef(({ type, param, id }, ref) => {
  // for lokesh
  const repeatOptions = [
    { label: "None", value: "" },
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
  ]

  const candidateStatusOptions = [
  { label: "Active", value: "Active" },
  { label: "InActive", value: "InActive" },
  { label: "DND(Do Not Disturb)", value: "DND(Do Not Disturb)" },
  { label: "Blacklisted", value: "Blacklisted" },
  { label: "Opt Out", value: "Opt-Out" },
];
  const autoFollowupOptions = [
    { label: "None", value: "" },
    { label: "1 Day", value: "1" },
    { label: "2 Days", value: "2" },
    { label: "3 Days", value: "3" },
  ]
  const reminderOptions = [
    { label: "None", value: "" },
    { label: "5 min", value: 5 },
    { label: "10 min", value: 10 },
    { label: "15 min", value: 15 },
    { label: "30 min", value: 30 },
    { label: "1 hour", value: 60 },
  ]
const candidateSidebarVisible = useSelector(state => state.calendar.visible);
document.title = "ATS - Candidates"

  const resume_import ="https://parsing.talentscan.ai/"

  const [dontShowOtherUI, setDontShowOtherUI] = useState(false)
  useImperativeHandle(ref, () => ({
    openPopup: () => {
      getdocumentsitems(id)
      geteditvaluescondidates(id)
      getAllActiveReceived(id) //Pipeline API
      getAllActiveActivies(id) //Activities API
      fetchCandidateNotes(id) //Notes API
      getAllHistory(id) //History API
      setVisibleViewRight(true)
      setDontShowOtherUI(true)
      setCandId(id)
    },
    closePopup: () => setVisibleViewRight(false),
  }))

  // for defaault dates and time for schedule

  const now = new Date()
  now.setSeconds(0, 0) // remove seconds/milliseconds

  const thirtyMinutesLater = new Date(now.getTime() + 30 * 60000)
  thirtyMinutesLater.setSeconds(0, 0)

  const dispatch = useDispatch()
  const { first, rows, totalRecords } = useSelector(
    state => state.calendar.pagination
  )
  // Sahiti coded from here

  const userInfo = JSON.parse(sessionStorage.getItem("user-info"))
  const userEmail = userInfo?.user_details?.email
  // console.log("userEmail", userEmail,userInfo);
  // Context menu options
  const [selectedCity, setSelectedCity] = useState(null)
  const [loading1, setLoading1] = useState(false)
  // datatable

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    first_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    last_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile_phone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    current_company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    total_experience: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    city_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    availability_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    relocation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    groups_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    resume: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    primary_skill_names: {
      value: null,
      matchMode: FilterMatchMode.STARTS_WITH,
    },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    EditDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    street_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  

  const [filtersActivityLog, setFiltersActivityLog] = useState({
    first_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    last_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    category_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    groups_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    updated_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    event_sub_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
    start_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    end_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })
  const [scheduleRepeat, setScheduleRepeat] = useState("") // Repeat value
  const [scheduleAutoFollowup, setScheduleAutoFollowup] = useState(false) // Auto followup checkbox
  const [scheduleReminder, setScheduleReminder] = useState("")
  const [selectedCandidateStatus, setSelectedCandidateStatus] = useState(candidateStatusOptions[0].value);
  

  // Initialize filters for each stage
  const initFilters = {
    stage: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jobid: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    candidate_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hiring_manager_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    candidate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    createdBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
  }
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [addressLabels, setAddressLabels] = useState([]);
  const [resumeSourceOptions, setResumeSourceOptions] = useState([]);
  
  const [isDuplicateEmail, setIsDuplicateEmail] = useState(false)
  const [duplicateCandidateId, setDuplicateCandidateId] = useState(null)
  const emailInputRef = useRef(null)
  const [labels] = useState([
    { label: "Work from Office (WFO)", value: "WORK" },
    { label: "Work from Home (WFH)", value: "HOME" },
    { label: "Work from Remote (WFR)", value: "REMOTE" },
  ])
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({
    // ...existing code...
    country: null,
    state: null,
    city: null,
    street_address: "",
    street_address_line_2: "",
    pincode: "",
    label: null,
    address: "", // Initialize address as empty
    source: null, // Resume source field
    // stage: null, // Stage field
    // ...existing code...
  })
  const [formErrors, setFormErrors] = useState({})
  const [tempAddressData, setTempAddressData] = useState({
    street_address: "",
    street_address_line_2: "",
    country: null,
    state: null,
    city: null,
    pincode: "",
    label: null,
  })

  const patterns = {
    // ...existing code...
    address: /^[a-zA-Z0-9\s,.-]{5,100}$/,
    pincode: /^[a-zA-Z0-9]{0,6}$/,
    // ...existing code...
  }
  const emailDebounceRef = useRef(null); 
  

  const fetchAddressLabels = async () => {
  try {
    const response = await axios.get(
      "/api/v1/get-all-address-label/"
    );
    if (response?.data?.results) {
      setAddressLabels(
        response.data.results.map(label => ({
          label: label.address_label,
          value: label.id,
        }))
      );
    }
  } catch (error) {
    console.error("Error fetching address labels:", error);
  }
};

const isActiveStatus = useMemo(() => selectedCandidateStatus === "Active", [selectedCandidateStatus]);

  const fetchResumeSource = async () => {
    try {
      const response = await axios.get("/api/v1/resume-source/");
      if (response?.data?.results) {
        setResumeSourceOptions(
          response.data.results.map(source => ({
            label: source.resume_source,
            value: source.source_id,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching resume sources:", error);
    }
  };
  //sai's code for email check
  const handleEmailBlur = async e => {
    const email = e.target.value?.trim()
    setIsDuplicateEmail(false)
    setDuplicateCandidateId(null)
    setEmailError("") // Clear previous email error

    if (!email) return

    try {
      const response = await axios.post(
        "/api/v1/candidates/check-email/",
        { email }
      )
      if (response.data.duplicate) {
        setIsDuplicateEmail(true)
        setDuplicateCandidateId(response.data.candidate_id)
        setEmailError("Candidate with this email already exists.")
        toast.current?.show({
          severity: "warn",
          summary: "Duplicate Email",
          detail:
            "Candidate with this email already exists. You can go to the edit page by clicking the Edit button below the email field.",
          life: 4000,
        })
      } else {
        setIsDuplicateEmail(false)
        setDuplicateCandidateId(null)
        setEmailError("")
      }
    } catch (err) {
      setIsDuplicateEmail(false)
      setDuplicateCandidateId(null)
      setEmailError("Failed to check duplicate email.")
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to check duplicate email.",
        life: 4000,
      })
    }
  }

  // Address validation in validateField
  const validateField = (name, value) => {
    let error = ""
    switch (name) {
      // ...existing code...
      case "street_address":
      case "street_address_line_2":
        if (value && !patterns.address.test(value))
          error = "Invalid address (5-100 chars)"
        break
      case "pincode":
        if (value && !patterns.pincode.test(value))
          error = "Invalid postal code (0-6 chars)"
        break
      case "state":
        if (formData?.country && !value)
          error = "Required when country is selected"
        break
      case "city":
        if (formData?.state && !value) error = "Required when state is selected"
        break
      case "source":
        if (!value) error = "Source is required"
        break
      // case "stage":
      //   if (!value) error = "Stage is required"
      //   break
      default:
        break
    }
    return error
  }

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    const error = validateField(field, value)
    setFormErrors(prev => ({ ...prev, [field]: error }))
  }
  const handleTempAddressChange = (field, value) => {
    setTempAddressData(prev => ({ ...prev, [field]: value }))
    const error = validateField(field, value)
    setFormErrors(prev => ({ ...prev, [field]: error }))
  }

  // Address dropdown API calls
  const fetchCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`)
      const countryData = (response?.data?.results || []).map(item => ({
        id: item?.id || item?.country_id,
        name: item?.name || item?.country_name || "Unknown Country",
      }))
      setCountries(countryData)
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err?.message ||
          "Failed to fetch countries"
      )
      console.error(err)
    }
  }
  const fetchStates = async countryId => {
    if (!countryId) return
    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`
      )
      const stateData = (response?.data?.results || []).map(item => ({
        id: item?.id || item?.state_id,
        name: item?.name || item?.state_name || "Unknown State",
      }))
      setStates(stateData)
      setTempAddressData(prev => ({ ...prev, state: null, city: null }))
      setCities([])
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Failed to fetch states"
      )
      console.error(err)
    }
  }
  const fetchCities = async stateId => {
    if (!stateId) return
    try {
      const response = await axios.get(
        `/api/v1/get-all-cities/?state_id=${stateId}`
      )
      const cityData = (response?.data?.results || []).map(item => ({
        id: item?.id || item?.city_id,
        name: item?.name || item?.city_name || "Unknown City",
      }))
      setCities(cityData)
      setTempAddressData(prev => ({ ...prev, city: null }))
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Failed to fetch cities"
      )
      console.error(err)
    }
  }

  const openAddressDialog = () => {
    setTempAddressData({
      street_address: formData.street_address,
      street_address_line_2: formData.street_address_line_2,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      pincode: formData.pincode,
      label: formData.label,
    })
    setVisible(true)
  }
  const handleAddressDialogOk = () => {
    const updatedAddress = [
      tempAddressData.street_address,
      tempAddressData.street_address_line_2,
      tempAddressData.city?.name,
      tempAddressData.state?.name,
      tempAddressData.country?.name,
      tempAddressData.pincode,
      addressLabels.find(l => l.value === tempAddressData.label)?.label,
    ]
      .filter(Boolean)
      .join("\n")
    setFormData(prev => ({
      ...prev,
      street_address: tempAddressData.street_address,
      street_address_line_2: tempAddressData.street_address_line_2,
      country: tempAddressData.country,
      state: tempAddressData.state,
      city: tempAddressData.city,
      pincode: tempAddressData.pincode,
      label: tempAddressData.label,
      address: updatedAddress,
    }))
    setVisible(false)
  }
  const handleAddressDialogCancel = () => {
    setTempAddressData({
      street_address: "",
      street_address_line_2: "",
      country: null,
      state: null,
      city: null,
      pincode: "",
      label: null,
    })
    setFormData(prev => ({
      ...prev,
      street_address: "",
      street_address_line_2: "",
      country: null,
      state: null,
      city: null,
      pincode: "",
      label: null,
      address: "",
    }))
    setVisible(false)
  }

  // Address-related useEffects
  useEffect(() => {
    fetchCountries()
    fetchAddressLabels();
    fetchResumeSource();
  }, [])
  useEffect(() => {
    if (tempAddressData.country?.id) {
      fetchStates(tempAddressData.country.id)
    }
  }, [tempAddressData.country])
  useEffect(() => {
    if (tempAddressData.state?.id) {
      fetchCities(tempAddressData.state.id)
    }
  }, [tempAddressData.state])

  const [selectedJobs, setSelectedJobs] = useState({})
  // To Restrict the import resume
  const fileUploadRef = useRef(null)

  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result.split(",")[1])
      reader.onerror = error => reject(error)
    })
  }
  const customBase64Uploader = async event => {
    setLoading(true)
    try {
      const file = event.files[0]
      if (!file) {
        throw new Error("No file selected")
      }

      // Validate file type
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/jpeg",
        "image/png",
      ]
      const maxFileSize = 5 * 1024 * 1024 // 5MB

      if (!allowedTypes.includes(file.type)) {
        throw new Error(
          "Invalid file type. Please upload PDF, DOC, DOCX, JPEG, or PNG files only."
        )
      }

      if (file.size > maxFileSize) {
        throw new Error("File size exceeds 5MB limit.")
      }

      // Prevent folder uploads
      if (file.size === 0 || !file.type) {
        throw new Error("Folders are not allowed. Please upload a valid file.")
      }

      const formData = new FormData()
      formData.append("resume_files", file)

      const response = await axios.post(
        resume_import + "api/resume/" ,
        formData,
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        //   timeout: 30000,
        // }
      )

      const base64Data = await getBase64(file)

      const resumeFile = {
        name: file.name,
        type: file.type,
        size: file.size,
        base64: base64Data,
      }

      if (response.status === 200) {
        navigate("/uploadresumeform", {
          state: { resumeData: response.data, resumeFile },
        })
      } else {
        throw new Error(`Unexpected response status: ${response.status}`)
      }
    } catch (error) {
      console.error("Error uploading file:", error)
      let errorMessage = "An unexpected error occurred"

      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = "Invalid request. Please check your file."
            break
          case 401:
            errorMessage = "Authentication failed. Please log in again."
            break
          case 403:
            errorMessage = "You do not have permission to upload."
            break
          case 413:
            errorMessage = "File is too large. Maximum 5MB allowed."
            break
          default:
            errorMessage =
              error.response.data.message ||
              `Server responded with status ${error.response.status}`
        }
      } else if (error.request) {
        errorMessage = "No response received from server."
      } else {
        errorMessage = error.message
      }

      // Show error and clear the FileUpload component
      warningAlert(errorMessage)
      if (fileUploadRef.current) {
        fileUploadRef.current.clear() // Reset the FileUpload component
      }
    } finally {
      setLoading(false)
    }
  }

  const [expandedRows, setExpandedRows] = useState({})

  const toggleExpand = rowId => {
    setExpandedRows(prev => ({
      ...prev,
      [rowId]: !prev[rowId],
    }))
  }

  const [filtersTaskList, setFiltersTaskList] = useState({
    event_type: { value: "", matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    event_sub_type: { value: "", matchMode: FilterMatchMode.CONTAINS },
    subject: { value: "", matchMode: FilterMatchMode.CONTAINS },
    description: { value: "", matchMode: FilterMatchMode.CONTAINS },
    reminder_note: { value: "", matchMode: FilterMatchMode.CONTAINS },
    status: { value: "", matchMode: FilterMatchMode.CONTAINS },
    time_zone: { value: "", matchMode: FilterMatchMode.CONTAINS },
    reminder: { value: "", matchMode: FilterMatchMode.CONTAINS },
    repeat: { value: "", matchMode: FilterMatchMode.CONTAINS },
    auto_followup: { value: "", matchMode: FilterMatchMode.CONTAINS },
    event_time: { value: "", matchMode: FilterMatchMode.CONTAINS }, // for date fields
  })

  // Add candidate form
  const {
    register,
    handleSubmit,
    reset,
    control,
    trigger,
    clearErrors,
    formState: { errors },
    setValue,
    getValues,
  } = useForm()
  const {
    register: registerViewCandidate,
    reset: resetViewCandidate,
    setValue: setValueViewCandidate,
  } = useForm()
  const initialAddressState = {
    street_address: "",
    street_address_line_2: "",
    country: null,
    state: null,
    city: null,
    pincode: "",
    label: null,
    address: "",
    source: null,
    stage: null,
  }

  const [primarySkillsview, setprimarySkillsview] = useState(null)
  const [primarySkillsget, setprimarySkillsget] = useState([])
  const [error, setError] = useState("")
  const [uniqueUserId, setUniqueUserId] = useState("")
  const [disable, setDisable] = useState(false)
  const [selectedNodeKey, setSelectedNodeKey] = useState(null)
  const [emailError, setEmailError] = useState("")
  const [resumeError, setResumeError] = useState("")
  const [filteredAdminstation, setFilteredAdminstation] = useState([])
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 })
  // newly added for model archived and unarchived
  const [smShow, setSmShow] = useState(false)
  const [smShowun, setSmShowun] = useState(false)
  const [deleteRowId, setDeleteRowId] = useState(null)
  // const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("")
  const [scheduleFormErrors, setScheduleFormErrors] = useState({
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
  })
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const [resumefileData, setResumeFileData] = useState([])
  const [visibleRight, setVisibleRight] = useState(false)
  const [selectedgroupKey, setselectedgroupKey] = useState(null)
  const [primarySkills, setPrimarySkills] = useState(null)
  const [stages, setStages] = useState([])

  const [actScheduleOptions, setActScheduleOptions] = useState([])
  const [selectedSchedule, setSelectedSchedule] = useState(null)
  const [scheduleCommonPopup, setScheduleCommonPopup] = useState(false)
  const [subtypeCall, setSubTypeCall] = useState(null)
  const [selectedScheduleJobs, setSelectedScheduleJobs] = useState(null)
  const [selectedScheduleContacts, setSelectedScheduleContacts] = useState([])
  const [selectedScheduleCandidates, setSelectedScheduleCandidates] =
    useState(null)
  const [selectedCandidate, setSelectedCandidate] = useState(null) // State to track the right-clicked candidate
  const [selectedCustomers, setSelectedCustomers] = useState([])
  const [typeInterviewcondi, settypeInterviewcondi] = useState([])
  const [scheduleSubtype, setScheduleSubtype] = useState(null)
  const [scheduleStartDate, setScheduleStartdate] = useState(now)
  const [scheduleStartTime, setScheduleStarttime] = useState(now)
  const [viewDetails, setViewDetails] = useState(null)
  const [scheduleEndTime, setScheduleEndTime] = useState(thirtyMinutesLater)
  const [scheduleEndDate, setScheduleEndDate] = useState(now)
  const [scheduleSubject, setScheduleSubject] = useState(null)
  const [schedulepopchecked2, setSchedulePopchecked2] = useState(false)
  const [schedulePriority, setSchedulePriority] = useState(null)
  const [stageData, setStageData] = useState({})

  const [showConfirmationDelete, setShowDeleteConfirmation] = useState(false)
  const [deleteCandidateData, setDeleteCandidateData] = useState([])

  // View States
  const [resumeDataforView, setResumeDataforView] = useState(null)

  const [pipelineData, setPipelineData] = useState({})
  const [stageCounts, setStageCounts] = useState({})

  // view form history starts

  const [historyFilters, setHistoryFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [history, setHistory] = useState([])

  const [selectedHistory, setSelectedHistory] = useState([])
  const [linkJobs, setLinkJobs] = useState([])

  // view form activities starts

  const [activitiesFilters, setActivitiesFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    sub_type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    priority: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    subject: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })
  const [activities, setActivities] = useState([])

  // permissions
  const [addPermission, setAddPermission] = useState(false)
  const [editPermission, setEditPermission] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [viewPermission, setViewPermission] = useState(false)

  useEffect(() => {
    if (type === "my-active-candidates") {
      const menu_id = menuIdData?.MyActiveCandidates
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (param === "archived_only=true") {
      const menu_id = menuIdData?.ArchivedCandidates
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "added_by_me") {
      const menu_id = menuIdData?.CandidatesAddedbyMe
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "opened_by_me") {
      const menu_id = menuIdData?.CandidatesOpenedbyMe
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "duplicate-candidates") {
      const menu_id = menuIdData?.CheckDuplicateCandidates
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "activity_log") {
      const menu_id = menuIdData?.CandidatesActivityLog
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else if (type === "task-list") {
      const menu_id = menuIdData?.CandidatesTaskList
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    } else {
      const menu_id = menuIdData?.AllActiveCandidates
      setAddPermission(get_user_menu_permission(menu_id, "add"))
      setEditPermission(get_user_menu_permission(menu_id, "edit"))
      setDeletePermission(get_user_menu_permission(menu_id, "delete"))
      setViewPermission(get_user_menu_permission(menu_id, "view"))
    }
  }, [])

  const [selectedActivities, setSelectedActivities] = useState([])

  // view form activities ends

  const handleEditCandidate = candidate => {
    if (candidate) {
      navigate(`/candidate-editform?candidate_id=${candidate.candidate_id}`)
    }
  }

  const [isLoading, setIsLoading] = useState(false)
  const [dynamicColumns, setDynamicColumns] = useState([])

  const notesCandidateRef = useRef(null)

  const emailCandidateRef = useRef(null)
  const submitCandidateRef = useRef()

  const moreACContactsRef = useRef()

  const handleContextMenuScheduleChange = scheduleType => {
    const selectedOption = actScheduleOptions.find(
      opt => opt.name === scheduleType
    )
    if (selectedOption) {
      setSelectedSchedule(selectedOption)
      setScheduleCommonPopup(true) // Open the dialog
      if (selectedOption.code) {
        fetchSubTypes(selectedOption.code) // Fetch subtypes based on selected schedule ID
      }
    }
  }

  const moreDropdownOptions = useMemo(() => {
  if (selectedCandidateStatus === "Active") {
    return [
      {
        label: "Link Jobs",
        icon: "pi pi-link",
        items: stages.map(stage => ({
          label: stage,
          icon: "pi pi-arrow-right",
          command: () => {
            moreACContactsRef.current?.openAttachments(stage)
          },
        })),
      },
      {
        label: "Change Status",
        icon: "pi pi-refresh",
        command: () => {
          const currentStatus =
            selectedCustomers[0]?.status ||
            selectedCustomers[0]?.value?.status ||
            "Applied";
          moreACContactsRef?.current?.openChangeStatus(currentStatus);
        },
      },
      {
        label: "Merge",
        icon: "pi pi-sync",
        command: () => moreACContactsRef?.current?.openMerge(),
      },
    ];
  } else {
    // Only show Change Status when not Active
    return [
      {
        label: "Change Status",
        icon: "pi pi-refresh",
        command: () => {
          const currentStatus =
            selectedCustomers[0]?.status ||
            selectedCustomers[0]?.value?.status ||
            "Applied";
          moreACContactsRef?.current?.openChangeStatus(currentStatus);
        },
      },
    ];
  }
}, [selectedCandidateStatus, stages, selectedCustomers]);
  

   const menuModel = selectedCandidateStatus === "Active" ? [
    ...(selectedCustomers.length <= 1
      ? [
          {
            label: "View",
            icon: "pi pi-fw pi-eye",
            visible: viewPermission,
            command: () => {
              const contact =
                selectedCustomers.length === 1
                  ? selectedCustomers[0]
                  : selectedCandidate
              if (contact) {
                const candId = contact.candidate_id
                getdocumentsitems(candId)
                geteditvaluescondidates(candId)
                getAllActiveReceived(candId) //Pipeline API
                getAllActiveActivies(candId) //Activities API
                fetchCandidateNotes(candId) //Notes API
                getAllHistory(candId) //History API
                setVisibleViewRight(true)
                setCandId(candId)
              }
            },
          },
        ]
      : []),

    ...(selectedCustomers.length <= 1
      ? [
          {
            label: "Edit",
            icon: "pi pi-fw pi-pencil",
            visible: editPermission,
            command: () => {
              const contact =
                selectedCustomers.length === 1
                  ? selectedCustomers[0]
                  : selectedCandidate
              handleEditCandidate(contact)
            },
          },
        ]
      : []),

    {
      label: param === "archived_only=true" ? "Unarchive" : "Archive",
      icon: "pi pi-check-circle",
      command: () => {
        const candidatesToArchive =
          selectedCustomers.length > 0 ? selectedCustomers : [selectedCandidate]
        archiveCandidate(candidatesToArchive)
      },
    },
    {
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      visible: deletePermission,
      command: () => {
        const candidatesToDelete =
          selectedCustomers.length > 0 ? selectedCustomers : [selectedCandidate]
        handleDeleteCandidate(candidatesToDelete)
      },
    },
    {
      label: "Email",
      icon: "pi pi-envelope",
      items: [
        // Subitems for "Schedule"
        {
          label: "New Email",
          icon: "pi pi-calendar-plus",
          command: () => emailCandidateRef.current?.openModal("new"),
        },
        {
          label: "Selected",
          icon: "pi pi-phone",
          command: () => emailCandidateRef.current?.openModal("selected"),
        },
        {
          label: "Searched",
          icon: "pi pi-users",
          command: () => emailCandidateRef.current?.openModal("searched"),
        },
        {
          label: "All",
          icon: "pi pi-list",
          command: () => emailCandidateRef.current?.openModal("all"),
        },
        {
          label: "Jobs",
          icon: "pi pi-calendar-clock",
          items: [
            // Subitems for "Schedule"
            {
              label: "All",
              icon: "pi pi-calendar-plus",
              command: () => emailCandidateRef.current?.openModal("jobs-all"),
            },
            {
              label: "Selected",
              icon: "pi pi-phone",
              command: () =>
                emailCandidateRef.current?.openModal("jobs-searched"),
            },
            {
              label: "Searched",
              icon: "pi pi-users",
              command: () =>
                emailCandidateRef.current?.openModal("jobs-searched"),
            },
          ],
        },
      ],
    },
    {
      label: "Schedule",
      icon: "pi pi-calendar-clock",
      items: [
        // Subitems for "Schedule"
        {
          label: "Interview",
          icon: "pi pi-calendar-plus",
          command: () => handleContextMenuScheduleChange("Interview"),
        },
        {
          label: "Call",
          icon: "pi pi-phone",
          command: () => handleContextMenuScheduleChange("Call"),
        },
        {
          label: "Meeting",
          icon: "pi pi-users",
          command: () => handleContextMenuScheduleChange("Meeting"),
        },
        {
          label: "Task",
          icon: "pi pi-list",
          command: () => handleContextMenuScheduleChange("Task"),
        },
        {
          label: "Event",
          icon: "pi pi-calendar-clock",
          command: () => handleContextMenuScheduleChange("Event"),
        },
        {
          label: "Other",
          icon: "pi pi-ellipsis-h",
          command: () => handleContextMenuScheduleChange("Other"),
        },
      ],
    },
    {
      label: "Candidate Notes",
      icon: "pi pi-clipboard",
      command: () => {
        setTimeout(() => {
          if (selectedCustomers.length > 0) {
            notesCandidateRef.current?.openNotes()
          }
        }, 0)
      },
    },
    {
      label: "Clear Search",
      icon: "pi pi-filter-slash",
      command: () => handleClearSearchCandidates(selectedCandidate),
    },
    {
      label: "Submit",
      icon: "pi pi-send",
      items: [
        // Subitems for "More"
        {
          label: "Submit Candidate to Job",
          icon: "pi pi-user-plus",
          command: () => submitCandidateRef.current?.openSubmitJob(),
        },
        {
          label: "Submit Candidate to Contact",
          icon: "pi pi-user-plus",
          command: () => submitCandidateRef.current?.openSubmitContact(),
        },
      ],
    },
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        {
          label: "Link Jobs",
          icon: "pi pi-link",
          items: stages.map(stage => ({
            label: stage,
            icon: "pi pi-arrow-right",
            command: () => {
              moreACContactsRef.current?.openAttachments(stage)
            },
          })),
        },
        {
          label: "Change Status",
          icon: "pi pi-refresh",
          command: () => {
            const currentStatus =
              selectedCustomers[0]?.status ||
              selectedCustomers[0]?.value?.status ||
              "Applied";
            moreACContactsRef?.current?.openChangeStatus(currentStatus);
          },
        },
        {
          label: "Merge",
          icon: "pi pi-sync",
          command: () => moreACContactsRef?.current?.openMerge(),
        },
      ],
    },
  ] : [
    {
      label: "More",
      icon: "pi pi-ellipsis-h",
      items: [
        {
          label: "Change Status",
          icon: "pi pi-refresh",
          command: () => {
            const currentStatus =
              selectedCustomers[0]?.status ||
              selectedCustomers[0]?.value?.status || selectedCandidateStatus;
            moreACContactsRef?.current?.openChangeStatus(currentStatus);
          },
        },
      ],
    },
  ]

  //categories and groups don eby lokesh

  const [categoryNodes, setCategoryNodes] = useState([])
  const [selectedCategoryNode, setSelectedCategoryNode] = useState(null)
  const [groupNodes, setGroupNodes] = useState([])
  const [selectedGroupNode, setSelectedGroupNode] = useState(null)
const [allDocumentTypes, setAllDocumentTypes] = useState([]);

const fetchAllDocumentTypes = async () => {
  try {
    const response = await axios.get("/api/v1/get-all-document-type/");
    setAllDocumentTypes(response.data.results || []);
  } catch (error) {
    setAllDocumentTypes([]);
  }
};

useEffect(() => {
  fetchAllDocumentTypes();
}, []);
  

  // Transform categories to tree structure
  const transformCategoriesToTree = categories => {
    const buildTree = category => ({
      key: category.category_id,
      label: category.name,
      data: category,
      children: category.subcategories
        ? category.subcategories.map(buildTree)
        : [],
    })

    return categories.map(buildTree)
  }

  // Transform groups to tree structure
  const transformGroupsToTree = groups => {
    const buildTree = group => ({
      key: group.group_id,
      label: group.name,
      data: group,
      children: group.subgroups ? group.subgroups.map(buildTree) : [],
    })

    return groups?.map(buildTree)
  }

  // Fetch categories
  const getCategories = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`)
      if (response?.data && response?.data?.results) {
        const treeData = transformCategoriesToTree(response?.data?.results)
        setCategoryNodes(treeData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }

  // Fetch groups
  const getGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`)
      if (response?.data && response?.data?.results) {
        const groupTree = transformGroupsToTree(response?.data?.results)
        setGroupNodes(groupTree)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }

  useEffect(() => {
    getCategories()
    getGroups()
  }, [])

  ///////////////// Helper funtions /////////////////////////

  const filterData = data =>
    data?.filter(
      item =>
        item?.first_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.job_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
        item?.current_company
          ?.toLowerCase()
          .includes(searchText?.toLowerCase()) ||
        item?.candidate_id?.toString().includes(searchText)
    )

  const onPageChange = event => {
    setLazyParams({ page: event.page, rows: event.rows })
    setSelectedCustomers([]);
  }
  // Resume Attachment fun for add candidate
  const handleFileChange = async event => {
    const file = event.target.files[0]
    if (!file) return
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ]
    if (!allowedTypes.includes(file.type)) {
      setResumeError(
        "Only PDF, Word (doc, docx), and image (jpg, jpeg, png) files are allowed."
      )
      setResumeFileData(null) // Clear resume file data
      return
    }
    const maxSize = 5 * 1024 * 1024
    if (file.size > maxSize) {
      setResumeError("File size should not exceed 5MB.")
      setResumeFileData(null) // Clear resume file data
      return
    }
    setResumeError("")
    try {
      const base64 = await getBase64(file)
      setResumeFileData({
        name: file.name,
        data: base64,
      })
    } catch (error) {
      console.error(error)
      setResumeError("Error while converting file to base64.")
      setResumeFileData(null) // Clear resume file data
    }
  }
const handleCanacelCreateCandidate = () => {
  resetCandidateSidebarForm();
  dispatch(setCandidateSidebarVisible(false));
};
  const closeSchedulePopup = () => {
    setScheduleCommonPopup(false)
    setSelectedSchedule(null)
    setSelectedScheduleJobs(null)
    setSelectedScheduleCandidates(null)
    setScheduleSubtype(null)
    setSelectedSchedule(null)
    setScheduleStartdate(null)
    setScheduleStarttime(null)
    setScheduleEndTime(null)
    setScheduleEndDate(null)
    setScheduleSubject(null)
    setSchedulePopchecked2(false)
    setScheduleFormErrors({})
    resetScheduleFields()
  }

  const handleDeleteCandidate = candidate => {
    // Ensure candidate is always treated as an array
    const candidatesToDelete = Array.isArray(candidate)
      ? candidate
      : [candidate]
    setDeleteCandidateData(candidatesToDelete)
    setShowDeleteConfirmation(true)
  }

  const handleDeleteClose = () => {
    setShowDeleteConfirmation(false)
    setDeleteCandidateData([])
  }

  // view page starts

  // Helper function to construct proper resume URL
  const getResumeUrl = (resumePath) => {
    if (!resumePath) return null;
    if (resumePath.startsWith('http')) return resumePath; // Already a complete URL
    return `${process.env.REACT_APP_API_BASE_URL}${resumePath}`;
  };

  // Define the downloadResume function
  const downloadResume = resumefileData => {
    downloadFile(resumefileData, "Resume.pdf")
  }

  ////////////////////// Get APIS ////////////////////////////

  const getskills = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-skills/`, {})
      const transformedData = response?.data?.results?.map(workv => ({
        name: workv?.skill_name,
        id: workv?.skill_id,
      }))
      setprimarySkillsget(transformedData)
    } catch (error) {
      console.error("Error fetching states:", error)
    }
  }
  const getcity = async () => {
    try {
      const response = await axios.get(`/api/v1/cities/`, {})
      const transformedData = response?.data?.results?.map(city => ({
        name: city?.name,
        city_id: city?.city_id,
      }))
      setaddCities(transformedData)
    } catch (error) {
      console.error("Error fetching cities:", error)
    }
  }
  const formatDate = date => {
    if (!date || !moment(date).isValid()) {
      return "N/A" // Return fallback text for null, empty, or invalid dates
    }
    return moment(date).format("YYYY-MM-DD")
  }

  const getprimary = async () => {
    try {
      const response = await axios.get(`/api/v1/skills/`, {})
      if (response.data && response.data.results) {
        const treeData = response.data.results
        setprimarySkillsvalu(treeData)
      }
    } catch (error) {
      console.error("Error fetching primary skills:", error)
    }
  }

  const getjobs = async () => {
    try {
      const response = await axios.get(`/api/v1/jobs/`, {})
      setLinkJobs(response?.data?.results || [])
      const transformedData = response?.data?.results?.map(city => ({
        name: city?.job_title,
        id: city?.job_id,
        job_number: city?.job_number,
      }))
      settypeInterviewval(transformedData)
    } catch (error) {
      console.error("Error fetching jobs:", error)
    }
  }

  const getallactivecontacts = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {})
      const transformedData = response?.data?.results?.map(city => ({
        name: city?.first_name,
        id: city?.contact_id,
      }))
      settypeInterviewcontact(transformedData)
    } catch (error) {
      console.error("Error fetching active contacts:", error)
    }
  }

  const getallinterviewdrop = async () => {
    try {
      const response = await axios.get(`/api/v1/event-lookup/`, {})
      const data = response.data
      const types = data?.Types?.map(type => ({
        label: type,
      }))

      setinterviewdroptype(types)
    } catch (error) {
      console.error("Error fetching interview drop types:", error)
    }
  }
  const resetCandidateSidebarForm = () => {
  reset({
    firstname: "",
    lastname: "",
    middle_name: "",
    personal_email: "",
    phone: "",
    jobtitle: "",
    Company: "",
    Availability: "",
    relocation: false,
    private: false,
  });
  setprimarySkillsview([]);
  setSelectedCategoryNode(null);
  setSelectedGroupNode(null);
  setSelectedCity(null);
  setResumeFileData(null);
  setError("");
  setFormData(prev => ({ ...prev, ...initialAddressState }));
  setTempAddressData({ ...initialAddressState });
  setEmailError("");
  setResumeError("");
  setFormErrors({});
  setIsDuplicateEmail(false);
  setDuplicateCandidateId(null);
  // Reset file input
  const fileInput = document.getElementById("MyPro_UploadedProfilePhoto_Modal_FilesInput");
  if (fileInput) fileInput.value = "";
};

  

  const getcategoriesitem = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`, {})
      if (response.data && response.data.results) {
        const transformedData = response?.data?.results?.map(Categories => ({
          name: Categories?.name,
          id: Categories?.category_id,
        }))
        setcategoriesitem(transformedData)
      }
    } catch (error) {
      console.error("Error fetching categories:", error)
    }
  }
  const getgroupsitem = async category_ids => {
    try {
      const response = await axios.get(
        `/api/v1/get-all-groups/?category_id=${category_ids}`,
        {}
      )
      if (response.data && response.data.results) {
        // const treeData = buildTreegroup(response.data.results);
        const transformedDatagroup = response?.data?.results?.map(Groups => ({
          name: Groups?.name,
          id: Groups?.group_id,
        }))
        setgroupitem(transformedDatagroup)
      }
    } catch (error) {
      console.error("Error fetching groups:", error)
    }
  }

  const [cpFirstName, setCpFirstName] = useState("")
  const [cpLastName, setCpLastName] = useState("")
  const geteditvaluescondidates = async candidate_id => {
    try {
      const response = await axios.get(
        `/api/v1/candidates/${candidate_id}/`,
        {}
      )
      if (response.status === 200) {
        let results = response.data

        setValueViewCandidate("first_name", results?.first_name)
        setCpFirstName(results?.first_name)
        setCpLastName(results?.last_name)
        setValueViewCandidate("last_name", results?.last_name)
        setValueViewCandidate("current_company", results?.current_company)
        setValueViewCandidate("job_title", results?.job_title)
        setValueViewCandidate("email", results?.email)
        setValueViewCandidate("mobile_phone", results?.mobile_phone)
        setValueViewCandidate("category", results?.category_name)
        setValueViewCandidate("group", results?.groups_name)
        setValueViewCandidate("relocation", results?.relocation || "")
        setavailabilityDate1(
          results?.availability_date
            ? new Date(results?.availability_date)
            : "-"
        )
        setResumeDataforView(results?.resume)
        console.log("Resume data:", results?.resume); // Debug log
        setNotes1(results?.candidate_notes || "")

        // ✅ Fix: Filter skills by ID from master skillOptions
        const matchedSkills = primarySkillsget
          ?.filter(skill => results?.primary_skills?.includes(skill.id))
          .map(skill => skill?.name) // only extract names

        setValueViewCandidate("primary_skills", matchedSkills)

        setViewDetails(results)
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error)
    }
  }

  // const getAllActive = async (page, size, selectedType = "", param = "") => {
  //   try {
  //     const endpoint =
  //       selectedType === "activity_log"
  //         ? `/api/v1/activity-log/?module=Candidate&page=${page}&size=${size}`
  //         : selectedType === "task-list"
  //         ? `/api/v1/events/task-list/?module=Candidate&page=${page}&size=${size}`
  //         : `/api/v1/candidates${selectedType ? "/" + selectedType : ""}/?${
  //             param ? param + "&" : ""
  //           }page=${page}&size=${size}`

  //     const response = await axios.get(endpoint)
  //     // const response = await axios.get(`/api/v1/candidates${selectedType ? '/' + selectedType : ''}/?${param ? param + '&' : ''}page=${page + 1}&size=${size}`,);
  //     if (response.status === 200) {
  //       const cols = Object.keys(response.data.results[0]).map(key => ({
  //         field: key,
  //         header: key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()),
  //       }))
  //       setDynamicColumns(cols)
  //       setFilteredAdminstation(response.data.results || [])
  //       dispatch(
  //         setPageData({
  //           first: (page - 1) * size,
  //           rows: size,
  //           totalRecords: response?.data?.count || 0,
  //         })
  //       )
  //       // setFilteredJobs(response.data.results || []);
  //       // setTotalRecords(response.data.count || 0)
  //       const transformedData = response.data.results.map(cond => ({
  //         name: cond.first_name,
  //         id: cond.candidate_id,
  //       }))
  //       settypeInterviewcondi(response.data.results || [])
  //       const transformedDataemail = response.data.results.map(cond => ({
  //         email: cond.email,
  //         id: cond.candidate_id,
  //       }))
  //       // settoEmail(transformedDataemail)
  //       // setccEmail(transformedDataemail)
  //     } else {
  //       setFilteredAdminstation([])
  //       setTotalRecords(0)
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch candidates", error)
  //   }
  // }

  const getAllActive = async (page, size, selectedType = "", param = "", statusValue = "Active") => {
    setLoading1(true); 
    try {
      const endpoint =
        selectedType === "activity_log"
          ? `/api/v1/activity-log/?module=Candidate&page=${page}&size=${size}&status=${statusValue}`
          : selectedType === "task-list"
          ? `/api/v1/events/task-list/?module=Candidate&page=${page}&size=${size}&status=${statusValue}`
          : `/api/v1/candidates${selectedType ? "/" + selectedType : ""}/?${
              param ? param + "&" : ""
            }page=${page}&size=${size}&status=${statusValue}`

      const response = await axios.get(endpoint)
      if (response.status === 200) {
        let results = response.data.results || []
        results = results?.map(candidate => ({
        ...candidate,
        current_company: candidate?.current_company === null || candidate?.current_company === "" ? "-" : candidate?.current_company,
      }));
        if (selectedType === "activity_log") {
          results = results
            .filter(item => item?.candidate)
            .map(item => ({
              id: item?.calendar_id,
              action: item?.action,
              timestamp: item?.timestamp,
              user: item?.user,
              notes: item?.notes,
              candidate_id: item?.candidate?.candidate_id,
              first_name: item?.candidate?.first_name,
              last_name: item.candidate?.last_name,
              email: item?.candidate?.email,
              job_title: item?.candidate?.job_title,
              categories: item?.candidate?.categories,
              groups: item?.candidate?.groups,
              created_at: item?.candidate?.created_at,
              created_by_name: item?.candidate?.created_by_name,
              updated_at: item?.candidate?.updated_at,
              category_name: item?.candidate?.category_name,
              description: item?.description,
              event_type: item?.event_type,
              event_sub_type: item?.event_sub_type,
              start_date: item?.start_date ? moment(item.start_date, "DD/MM/YYYY").format("YYYY-MM-DD") : item?.start_date,
              end_date: item?.end_date ? moment(item.end_date, "DD/MM/YYYY").format("YYYY-MM-DD") : item?.end_date,
              subject: item?.subject,
              status: item?.status,
              groups_name: item?.candidate?.groups_name,
            }))
        }
        if (selectedType === "task-list") {
          results = results?.filter(item => item?.candidate)?.map(item => ({
              id: item?.calendar_id,
              action: item?.action,
              timestamp: item?.timestamp,
              user: item?.user,
              notes: item?.notes,
              candidate_id: item?.candidate.candidate_id,
              first_name: item?.candidate?.first_name,
              last_name: item?.candidate?.last_name,
              email: item?.candidate?.email,
              job_title: item?.candidate?.job_title,
              categories: item?.candidate?.categories,
              groups: item?.candidate?.groups,
              created_at: item?.candidate?.created_at,
              created_by_name: item?.candidate?.created_by_name,
              updated_at: item?.candidate?.updated_at,
              category_name: item?.candidate?.category_name,
              groups_name: item?.candidate?.groups_name,
              description: item?.description,
              event_type: item?.event_type,
              event_sub_type: item?.event_sub_type,
              start_date: item?.start_date ? moment(item.start_date, "YYYY-MM-DD").format("YYYY-MM-DD") : item?.start_date,
              end_date: item?.end_date ? moment(item.end_date, "YYYY-MM-DD").format("YYYY-MM-DD") : item?.end_date,
              subject: item?.subject,
              status: item?.status,
            }))
        }

        const cols = Object?.keys(results[0] || {})?.map(key => ({
          field: key,
          header: key?.replace(/_/g, " ")?.replace(/\b\w/g, l => l.toUpperCase()),
        }))
        setDynamicColumns(cols)
        setFilteredAdminstation(results)
        setSelectedCustomers([])
        dispatch(
          setPageData({
            first: (page - 1) * size,
            rows: size,
            totalRecords: response?.data?.count || 0,
          })
        )
        const transformedData = results?.map(cond => ({
          name: cond?.first_name,
          id: cond?.candidate_id,
        }))
        settypeInterviewcondi(results)
        const transformedDataemail = results?.map(cond => ({
          email: cond?.email,
          id: cond?.candidate_id,
        }))
      } else {
        setFilteredAdminstation([])
        // setTotalRecords(0)
      }
    } catch (error) {
      console.error("Failed to fetch candidates", error)
      setFilteredAdminstation([])
      // setTotalRecords(0)
    }
    finally {
    setLoading1(false); // Hide loader after fetching
  }
  }

  const fetchScheduleOptions = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-schedule-type/`)
      const scheduleData = response.data?.results || []

      // Transform API data into hierarchical structure for CascadeSelect
      const transformedOptions = scheduleData?.map(schedule => ({
        name: schedule?.schedule_type || "Unnamed Schedule",
        code: schedule?.id || "",
      }))

      setActScheduleOptions(transformedOptions)
    } catch (error) {
      console.error("Error fetching schedule types:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch schedule types. Using default options.",
        life: 3000,
      })
    }
  }
  // const fetchScheduleSubTypeOptions = async () => {
  //   try {
  //     const response = await axios.get("/api/v1/schedule-sub-type/");

  //     if (response.status === 200) {
  //       const options = response.data.results.map((option) => ({
  //         name: option.schedule_subtype,
  //         id: option.schedule_subtype_id
  //       }));
  //       setSubTypeCall(options);

  //     }

  //   } catch (err) {
  //     console.error("Failed to fetch schedule types", err);
  //     triggerAlert("error", "Error", "Failed to fetch schedule types. Please try again.");
  //   }
  // };

  const fetchStages = async () => {
    try {
      const response = await axios.get("/api/v1/get-all-stages/")
      if (response?.data && response?.data?.results) {
        // Sort stages by order
        const sortedStages = response?.data?.results
          .sort((a, b) => a?.order - b?.order)
          .map(stage => stage?.name?.toLowerCase())
        setStages(sortedStages)

        // Initialize state for each stage
        const initialPipelineData = {}
        const initialStageCounts = {}
        const initialSelectedJobs = {}
        const initialFilters = {}
        sortedStages.forEach(stage => {
          initialPipelineData[stage] = []
          initialStageCounts[stage] = 0
          initialSelectedJobs[stage] = []
          initialFilters[stage] = initFilters
        })
        setPipelineData(initialPipelineData)
        setStageCounts(initialStageCounts)
        setSelectedJobs(initialSelectedJobs)
        // setFilters(initialFilters);
      } else {
        console.warn("No stages found in API response.")
        setStages([])
      }
    } catch (error) {
      console.error("Error fetching stages:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch stages. Please try again.",
        life: 3000,
      })
    }
  }

  useEffect(() => {
    fetchStages()
  }, [])

  useEffect(() => {
    const validateDates = () => {
      const errors = { ...scheduleFormErrors }

      // Reset errors
      errors.start_date = ""
      errors.end_date = ""

      if (scheduleStartDate && scheduleEndDate) {
        const start = new Date(scheduleStartDate)
        start.setHours(0, 0, 0, 0)
        const end = new Date(scheduleEndDate)
        end.setHours(0, 0, 0, 0)

        if (start.getTime() > end.getTime()) {
          errors.start_date = "Start date cannot be after end date"
        } else if (end.getTime() < start.getTime()) {
          errors.end_date = "End date cannot be before start date"
        }

        // Validate times when dates are valid
        if (
          start.getTime() <= end.getTime() &&
          scheduleStartTime &&
          scheduleEndTime
        ) {
          const startTime = new Date(scheduleStartTime).getTime()
          const endTime = new Date(scheduleEndTime).getTime()

          if (startTime >= endTime && start.getTime() === end.getTime()) {
            errors.start_time = "Start time must be before end time"
          } else {
            errors.start_time = ""
            errors.end_time = ""
          }
        }
      }

      setScheduleFormErrors(errors)
    }

    validateDates()
  }, [scheduleStartDate, scheduleEndDate, scheduleStartTime, scheduleEndTime])

  const handleresend = () => {
    setVisibleLinkJob(true)
  }

  //View Page APIs
  const getAllActiveReceived = async candidate_id => {
    if (!candidate_id) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong, Please refresh the page and try again",
      })
      return
    }
    try {
      const response = await axios.get(
        `/api/v1/stages/job_candidates_by_stage/?candidate_id=${candidate_id}`,
        {}
      )
      if (response.data && response.data.results) {
        // Transform the API response to match DataTable structure
        const newPipelineData = {}
        const newStageCounts = {}
        stages?.forEach(stage => {
          newPipelineData[stage] = []
          newStageCounts[stage] = 0
        })

        response?.data?.results?.forEach(stageData => {
          const stageKey = stageData?.stage_name?.toLowerCase()
          if (stages?.includes(stageKey)) {
            newStageCounts[stageKey] = stageData?.count || 0
            newPipelineData[stageKey] = stageData?.candidates?.map(candidate => ({
              stage: stageData?.stage_name,
              jobid: candidate?.job?.job_number || "N/A",
              job_title: candidate?.job?.job_title || "N/A",
              company_name: candidate?.job?.company_name || "N/A",
              hiring_manager_name: candidate?.job?.hiring_manager_name || "N/A",
              candidate_name: candidate?.candidate_name || "N/A",
              status: candidate?.status || "N/A",
              create_date: candidate?.created_at
                ? moment(candidate?.created_at).format("YYYY-MM-DD")
                : "N/A",
              createdBy: candidate?.created_by_meta ? candidate?.created_by_meta : candidate?.created_by_name || "N/A",
              candidate: candidate?.candidate_name || "N/A",
              location: candidate?.job?.location || "N/A",
            }))
          }
        })

        setPipelineData(newPipelineData)
        setStageCounts(newStageCounts)
      } else {
        console.warn("No results found in API response.")
        const emptyPipelineData = {}
        const emptyStageCounts = {}
        stages?.forEach(stage => {
          emptyPipelineData[stage] = []
          emptyStageCounts[stage] = 0
        })
        setPipelineData(emptyPipelineData)
        setStageCounts(emptyStageCounts)
      }
    } catch (error) {
      console.error("Error fetching pipeline data:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch pipeline data. Please try again.",
        life: 3000,
      })
      const emptyPipelineData = {}
      const emptyStageCounts = {}
      stages?.forEach(stage => {
        emptyPipelineData[stage] = []
        emptyStageCounts[stage] = 0
      })
      setPipelineData(emptyPipelineData)
      setStageCounts(emptyStageCounts)
    }
  }
  const getAllActiveActivies = async candidate_id => {
    try {
      const response = await axios.get(
        `/api/v1/activity-log/?candidate_id=${candidate_id}`,
        {}
      )
      if (response.status === 200) {
        const transformCandidates = candidates =>
          candidates?.map(candidate => ({
            type: candidate?.event_type,
            sub_type: candidate?.event_sub_type,
            priority: candidate?.event_priority,
            subject: candidate?.subject,
            date_time: candidate?.event_time,
            user_id: candidate?.created_by_name,
            status: candidate?.status,
          }))

        const activities = transformCandidates(response.data.results)
        setActivities(activities)
      }
    } catch (error) {
      console.error("Error fetching activities:", error)
    }
  }
  const getAllHistory = async candidate_id => {
    try {
      const response = await axios.get(
        `/api/v1/history/?candidate_id=${candidate_id}`,
        {}
      )
      if (response.status === 200) {
        // const transformCandidates = (candidates) =>
        //   candidates.map((candidate) => ({
        //     type: candidate.action_type,
        //     sub_type: candidate.sub_type,
        //     ip_address: candidate.ip_address,
        //     subject: candidate.description,
        //     date_time: candidate.action_date,
        //     user_id: candidate.created_by_name,
        //   }));
        // const activities = transformCandidates(response.data.results);
        const activities = response?.data?.results
        setHistory(activities)
      }
    } catch (error) {
      console.error("Error fetching history:", error)
    }
  }

  /////////// POST APIS //////////////////////

  const onCellEditComplete = e => {
    const { rowData, newValue, field } = e
    const updatedData = [...filteredAdminstation]
    const rowIndex = updatedData.findIndex(
      row => row.candidate_id === rowData.candidate_id
    )
    // --- Validation Rules ---
    const validations = [
      {
        isValid: /^[A-Za-z][A-Za-z-\s&,]*$/.test(newValue),
        message:
          "Only alphabets and spaces are allowed, and value should not start with a space.",
      },
      {
        isValid: newValue.length <= 100,
        message: "Maximum 100 characters are allowed.",
      },
      {
        isValid: newValue.length >= 1,
        message: "Minimum 1 character is required.",
      },
    ]

    const failedValidation = validations.find(rule => !rule.isValid)

    if (failedValidation) {
      toast.current?.show({
        severity: "error",
        summary: "Validation Error",
        detail: failedValidation.message,
      })
      return // 🚫 STOP further execution
    }
    if (rowIndex !== -1) {
      updatedData[rowIndex][field] = newValue
      setFilteredAdminstation(updatedData) // Update UI optimistically

      // const token =`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJ1c2VybmFtZSI6bnVsbCwiZW1haWwiOiJzdXBlcmFkbWluQGV4YW1wbGUuY29tIiwicm9sZXMiOlsiU3VwZXJ1c2VyIFJvbGUiXSwicGVybWlzc2lvbnMiOlsibWFuYWdlX3VzZXJzIiwibWFuYWdlX3JvbGVzIiwibWFuYWdlX3Blcm1pc3Npb25zIiwibWFuYWdlX3JvbGVfdG9fZW1wbG95ZWUiXSwiZXhwIjoxNzM0MDcwMzc0fQ.xLAYJjhDHW_3V-NVKS4wWavzyBCmZVzfwsS7RPIDepw`

      // API PATCH Request
      axios
        .patch(
          `/api/v1/candidates/${rowData.candidate_id}/`,
          { [field]: newValue } // Send only the updated field
        )
        .then(() => {
          const page = Math.floor(first / rows) + 1
          getAllActive(page, rows, type, param)
        })
        .catch(error => {
          // Optionally, revert UI change if the API request fails
          updatedData[rowIndex][field] = rowData[field]
          setFilteredAdminstation(updatedData)
        })
    }
  }

  //refresh api
  const refreshCandidates = () => {
    const page = Math.floor(first / rows) + 1
    getAllActive(page, rows, type, param, selectedCandidateStatus)
  }
  //Create Candidate API
  const onSubmit = async data => {
    if (isDuplicateEmail) {
      setEmailError("Candidate with this email already exists.")
      setTimeout(() => {
        if (
          emailInputRef.current &&
          typeof emailInputRef.current.scrollIntoView === "function"
        ) {
          emailInputRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          })
          emailInputRef.current.focus()
        }
      }, 200)
      return
    }
    
    // Validate mandatory fields
    const validationErrors = {}
    
    if (!formData.source) {
      validationErrors.source = "Source is required"
    }
    
    // if (!formData.stage) {
    //   validationErrors.stage = "Stage is required"
    // }
    
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors)
      return
    }
    
    if (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "Invalid resume file format. Only PDF and Word files are allowed.",
      })
      return
    }

    setLoading(true)
    setDisable(true)
    const req = {}

    if (data.lastname) {
      req.last_name = data.lastname
    }
    if (data.middle_name) {
      req.last_name = data.middle_name
    }
    if (data.jobtitle) {
      req.job_title = data.jobtitle
    }
    if (data.designation) {
      req.designation = data.designation
    }
    if (data.phone) {
      req.mobile_phone = data.phone
    }
    if (selectedCategoryNode) {
      req.categories = selectedCategoryNode
    }
    if (selectedGroupNode) {
      req.groups = selectedGroupNode
    }
    if (data.Company) {
    req.current_company = data.Company;
  }
    if (data.Availability) {
      req.availability_date = data.Availability
    }
    if (primarySkillsview) {
      req.primary_skills = primarySkillsview
    }
    if (selectedCity) {
      req.city = selectedCity
    }
    req.first_name = data?.firstname
    req.email = data.personal_email
    req.relocation = data.relocation ? "true" : "false"
    req.private = data.private ? "true" : "false"
    if (resumefileData) {
      req.resume = {
        file_name: resumefileData.name,
        file_data: resumefileData.data,
      }
    }

    // Address fields added newly

    req.street_address = formData.street_address || null
    req.street_address_line_2 = formData.street_address_line_2 || null
    req.country = formData.country?.id || null
    req.state = formData.state?.id || null
    req.city = formData.city?.id || null
    req.pincode = formData.pincode || null
    req.label = formData.label || null
    req.address = formData.address || null
    req.address_label = formData.label || null
    req.source = formData.source || null
    req.stage = formData.stage || null

    try {
      const response = await axios.post(`/api/v1/candidates/`, req, {})
      const page = Math.floor(first / rows) + 1
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: `Candidate created successfully`,
      })
      getAllActive(page, rows, type, param)
      resetCandidateSidebarForm();
      dispatch(setCandidateSidebarVisible(false));
      reset()
      setprimarySkillsview([])
      setSelectedCategoryNode(null)
      setSelectedGroupNode(null)
      setSelectedCity(null)
      setResumeFileData(null) // Clear resume file data
      setError("") // Clear error message
      setFormData(prev => ({ ...prev, ...initialAddressState }))
      setTempAddressData({ ...initialAddressState })
      setEmailError("")
      setResumeError("")
      setIsDuplicateEmail(false)
      setDuplicateCandidateId(null)
    } catch (error) {
      console.error(error)
      const errorMessage =
        error?.response?.data?.error || "Something went wrong"
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errorMessage,
      })
    } finally {
      setLoading(false)
      setDisable(false)
    }
  }

  const validateScheduleForm = () => {
    const errors = {}

    if (!selectedSchedule?.name) {
      errors.event_type = "Event type is required.*"
    }

    if (!scheduleSubtype?.name) {
      errors.event_sub_type = "Event subtype is required.*"
    }

    if (!scheduleStartDate) {
      errors.start_date = "Start date is required.*"
    }

    if (!scheduleEndDate) {
      errors.end_date = "End date is required.*"
    }

    if (!scheduleStartTime) {
      errors.start_time = "Start time is required.*"
    }

    if (!scheduleEndTime) {
      errors.end_time = "End time is required.*"
    }

    // if (!scheduleSubject?.trim()) {
    //   errors.subject = "Subject is required.*"
    // }



    // sai's code
    const scheduleType = (selectedSchedule?.name || "").toLowerCase()
    // Removed mandatory validation for autofollowup

    return errors
  }
  const onSubmitSchedule = async e => {
    e.preventDefault()
    const errors = validateScheduleForm()
    setScheduleFormErrors(errors)

    if (Object.keys(errors).length > 0) {
      console.warn("Validation failed:", errors)
      return
    }

    const payload = {
      event_sub_type: scheduleSubtype?.name || "",
      event_type: selectedSchedule?.name || "",
      end_date: scheduleEndDate
        ? scheduleEndDate.toISOString().split("T")[0]
        : "",
      start_date: scheduleStartDate
        ? scheduleStartDate.toISOString().split("T")[0]
        : "",
      start_time: scheduleStartTime
        ? scheduleStartTime.toTimeString().split(" ")[0]
        : "",
      end_time: scheduleEndTime
        ? scheduleEndTime.toTimeString().split(" ")[0]
        : "",
      candidate_id:
        selectedCustomers.length > 0
          ? selectedCustomers?.map(c => c?.candidate_id)
          : selectedScheduleCandidates?.map(c => c?.id) || [],
      candidates:
        selectedCustomers?.length > 0
          ? selectedCustomers?.map(c => c?.email)
          : selectedScheduleCandidates?.map(c => c?.email) || [],
      subject: scheduleSubject || "",
      job_id: selectedScheduleJobs?.map(c => c?.id) || [],
      event_time:
        scheduleStartDate && scheduleStartTime
          ? new Date(
              scheduleStartDate?.toISOString().split("T")[0] +
                "T" +
                scheduleStartTime?.toTimeString().split(" ")[0] +
                "Z"
            ).toISOString()
          : "",
      event_priority: schedulePriority?.name || "Low",
      private: schedulepopchecked2,
      completed: popchecked,
      body: popTextares,
      contact_id: selectedScheduleContacts || [],
      reminder: scheduleReminder,
      ...(scheduleRepeat && { repeat: repeatOptions.find(opt => opt.value === scheduleRepeat)?.label }),
      ...(scheduleAutoFollowup && { auto_followup: autoFollowupOptions.find(opt => opt.value === scheduleAutoFollowup)?.label }),
    }

    try {
      const response = await axios.post("/api/v1/events/", payload)

      if (response.status === 201) {
                
        toast.current.show({
          severity: "success",
          summary: "Schedule",
          detail: `Schedule Created Successfully`,
        })
        setScheduleCommonPopup(false)
        const page = Math.floor(first / rows) + 1
        getAllActive(page, rows, type, param)
        clearForm() // Clear form after successful submission
      }
    } catch (error) {
      console.error("Submission error", error)
      toast.current.show({
        severity: "error",
        summary: "Schedule",
        detail: error.response.data.error || 'Failed to create schedule',
      })
      setScheduleCommonPopup(false)
      clearForm() // Clear form on error
    }
  }

  const resetScheduleFields = () => {
    const now = new Date()
    now.setSeconds(0, 0)
    const thirtyMinutesLater = new Date(now.getTime() + 30 * 60000)
    thirtyMinutesLater.setSeconds(0, 0)

    setScheduleStartdate(now)
    setScheduleStarttime(now)
    setScheduleEndDate(now)
    setScheduleEndTime(thirtyMinutesLater)
    setScheduleSubtype(null)
    setSelectedSchedule(null)
    setSelectedScheduleCandidates([])
    setSelectedScheduleJobs([])
    setScheduleSubject("")
    setSchedulePriority(null)
    setPopTextares("")
    setSelectedScheduleContacts([])
    setSchedulePopchecked2(false)
    setPopchecked(false)
    setScheduleFormErrors({})
    setScheduleRepeat("")
    setScheduleAutoFollowup("")
    setScheduleReminder(10)
  }

  const archiveCandidate = async candidate => {
    // Ensure candidate is an array, convert single object to array if needed
    const candidatesArray = Array.isArray(candidate) ? candidate : [candidate]
    const candidate_ids = candidatesArray
      .filter(c => c && c?.candidate_id) // Filter out undefined/null candidates
      .map(c => c?.candidate_id)

    if (candidate_ids.length === 0) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "No valid candidates selected for archiving.",
      })
      return
    }

    setDeleteRowId(candidate_ids)
    if (param === "archived_only=true") {
      setSmShowun(true) // Show unarchive modal
    } else {
      setSmShow(true) // Show archive modal
    }
  }
  const archivedHandler = async () => {
    try {
      const response = await axios.patch(
        `/api/v1/candidates/${deleteRowId}/archive/`
      )
      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Archive",
          detail: "Archived successfully",
        })
        const page = Math.floor(first / rows) + 1
        getAllActive(page, rows, type, param)
      }
    } catch (error) {
      console.error("Archiving error", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Archiving failed",
      })
    } finally {
      setSmShow(false)
      setSelectedCustomers([])
      setDeleteRowId(null)
    }
  }
  const unarchivedHandler = async () => {
    try {
      // Send all candidate IDs in deleteRowId array
      const promises = deleteRowId?.map(id =>
        axios.patch(`/api/v1/candidates/${id}/unarchive/`)
      )
      const responses = await Promise.all(promises)

      // Check if all requests were successful
      if (responses?.every(response => response?.status === 200)) {
        toast.current.show({
          severity: "success",
          summary: "Unarchive",
          detail: "Unarchived successfully",
        })
        const page = Math.floor(first / rows) + 1
        getAllActive(page, rows, type, param)
      }
    } catch (error) {
      console.error("Unarchiving error", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Unarchiving failed",
      })
    } finally {
      setSmShowun(false)
      setSelectedCustomers([])
      setDeleteRowId(null)
    }
  }

  const deleteCandidate = async () => {
    try {
      // Extract candidate IDs from deleteCandidateData
      const candidateIds = deleteCandidateData
        .map(c => c?.candidate_id)
        .filter(id => id) // Filter out any undefined/null IDs
        .join(",")

      if (!candidateIds) {
        toast.current.show({
          severity: "error",
          summary: "Delete Failed",
          detail: "No valid candidates selected for deletion.",
        })
        return
      }

      const response = await axios.delete(`/api/v1/candidates/${candidateIds}/`)

      if (response.status === 200) {
        toast.current.show({
          severity: "success",
          summary: "Candidate Deleted",
          detail: `Deleted ${deleteCandidateData.length} candidate(s) successfully`,
        })

        const page = Math.floor(first / rows) + 1
        getAllActive(page, rows, type, param)
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Delete Failed",
        detail: "Failed to delete candidates.",
      })
      console.error("Delete error:", error)
    } finally {
      handleDeleteClose()
      setSelectedCustomers([])
      setSelectedCandidate(null) // Clear selected candidate after deletion
    }
  }

  

  const clearForm = () => {
    setScheduleStartdate(null)
    setScheduleStarttime(null)
    setScheduleEndDate(null)
    setScheduleEndTime(null)
    setScheduleSubtype(null)
    setSelectedSchedule(null)
    setSelectedScheduleCandidates([])
    setSelectedScheduleJobs([])
    setScheduleSubject("")
    setSchedulePriority(null)
    setPopTextares("")
    setSelectedScheduleContacts([])
    setSchedulePopchecked2(false)
    setPopchecked(false)
    setScheduleFormErrors({})
    setScheduleRepeat("")
    setScheduleAutoFollowup("")
    setScheduleReminder(10)
  }

  //////////// Use Effect ////////////////////////

  useEffect(() => {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info"))
    if (userInfo && userInfo?.user_details) {
      setUniqueUserId(userInfo?.user_details?.unique_user_id)
      setUserid([userInfo?.user_details?.unique_user_id])
    }
    getskills()
    getcity()
    getprimary()
    getjobs()
    getallactivecontacts()
    getallinterviewdrop()
    getcategoriesitem()
    fetchScheduleOptions()
  }, [])

  useEffect(() => {
    if (candidateSidebarVisible && selectedNodeKey) {
      getgroupsitem(selectedNodeKey)
    }
  }, [selectedNodeKey])

  useEffect(() => {
    const page = Math.floor(first / rows) + 1
    getAllActive(page, rows, type, param, selectedCandidateStatus)
    console.log("Fetching candidates with params:", { first, rows, type, param, selectedCandidateStatus })
  }, [first, rows, type, param, selectedCandidateStatus])

  const onPage = e => {
    const newPage = Math.floor(e.first / e.rows) + 1
    dispatch(
      setPageData({
        first: e.first,
        rows: e.rows,
        totalRecords,
      })
    )
    getAllActive(newPage, e.rows, type, param)
    setSelectedCustomers([]); 
  }

  useEffect(() => {
    if (candidateSidebarVisible) {
      reset({
        firstname: "",
        lastname: "",
        middle_name: "",
        personal_email: "",
        phone: "",
        jobtitle: "",
        Company: "",
        Availability: "",
        relocation: false,
        private: false,
      })
      setprimarySkillsview([])
      setSelectedCategoryNode(null)
      setSelectedGroupNode(null)
      setSelectedCity(null)
      setResumeFileData(null)
      setError("")
      const fileInput = document.getElementById(
        "MyPro_UploadedProfilePhoto_Modal_FilesInput"
      )
      if (fileInput) {
        fileInput.value = ""
      }
    }
  }, [candidateSidebarVisible, reset])

  // useEffect(() => {
  //   if (scheduleCommonPopup) fetchScheduleSubTypeOptions();

  // }, [scheduleCommonPopup]);

  //Sahiti coded till here ///////////

  // more

  // action items


  const dt = useRef(null)

  const [successAlertinter, setsuccessAlertinter] = useState(false)

  const [visibleViewRight, setVisibleViewRight] = useState(false)

  {
    /* Side bar end */
  }

  const textEditor = options => {
    return (
      <InputText
        value={options.value}
        onChange={e => options.editorCallback(e.target.value)}
      />
    )
  }

  const [categoriesitem, setcategoriesitem] = useState([])
  const [groupitem, setgroupitem] = useState([])

  const [HaveImagePan, setHaveImagePan] = useState(false)

  const [selectedRow, setSelectedRow] = useState(null)
  const contextMenu = useRef(null)
  const [candId, setCandId] = useState(null)

  // const [selectedCity, setSelectedCity] = useState(null)

  // interview

  const [city, setCity] = useState("")

  const [userIds, setUserIds] = useState("Harish")
  const [availabilityDate1, setavailabilityDate1] = useState("")
  const [editingRow, setEditingRow] = useState(null)
  const [editedValue, setEditedValue] = useState({})
  const [documents, setDocuments] = useState([])

  // Start editing a row
  const handleEdit = rowKey => {
    setEditingRow(rowKey)
    setEditedValue(documents.find(doc => doc.key === rowKey)?.data || {})
  }
  // Save the edited data
// ...existing code...
const handleSave = async () => {
  const candidateId = selectedCustomers[0]?.candidate_id;
  if (!editedValue.certificate_name || !editedValue.docSubject) {
    console.error("Document not found for editingRow:", editingRow);
    return;
  }

  const payload = {
    candidate_id: candidateId,
        document_type: allDocumentTypes.find(dt => dt.id === editedValue.certificate_name)?.value || editedValue.certificate_name,
    document_subject: editedValue.docSubject,
  };

  try {
    await axios.put(
      `/api/v1/documents/${editingRow}/`,
      payload
    );
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        doc?.key === editingRow ? { ...doc, data: editedValue } : doc
      )
    );
    setEditingRow(null);
  } catch (error) {
    console.error("Error updating document:", error?.response?.data || error.message);
  }
};

  // Cancel editing
  const handleCancel = () => {
    setEditingRow(null)
  }

  // Delete a row
  const handleDelete = async rowKey => {
    try {
      await axios.delete(`/api/v1/documents/${rowKey}/`);
      setDocuments(prevDocuments =>
        prevDocuments?.filter(doc => doc?.key !== rowKey)
      );
    } catch (error) {
      console.error("Error deleting document:", error?.response?.data || error.message);
    }
  }

  // Editable input field
  const editableTemplate = (rowData, field) => {
    if (field === "certificate_name") {
    return editingRow === rowData.key ? (
      <Dropdown
        value={editedValue.certificate_name}
        options={allDocumentTypes.map(dt => ({
          label: dt.value,
          value: dt.id,
        }))}
        onChange={e =>
          setEditedValue({ ...editedValue, certificate_name: e.value })
        }
        placeholder="Select Document Type"
        className="w-full"
        filter
        optionLabel="label"
        optionValue="value"
      />
    ) : (
      <span onClick={() => handleEdit(rowData.key)}>
        {
          allDocumentTypes.find(dt => dt.id === rowData.data.certificate_name)?.value
          || rowData.data.certificate_name
        }
      </span>
    );
  }
    return editingRow === rowData.key ? (
      <InputText
        value={editedValue[field] || ""}
        onChange={e =>
          setEditedValue({ ...editedValue, [field]: e.target.value })
        }
        autoFocus
      />
    ) : (
      <span onClick={() => handleEdit(rowData.key)}>{rowData.data[field]}</span>
    )
  }

  // Action buttons
  const actionTemplate = rowData => {
    return (
      <div className="flex gap-2">
        {editingRow === rowData.key ? (
          <>
            <Button
              icon="pi pi-check"
              rounded
              outlined
              className="document-btn"
              onClick={handleSave}
            />
            <Button
              icon="pi pi-times"
              rounded
              outlined
              className="document-btn"
              onClick={handleCancel}
            />
          </>
        ) : (
          <Button
            icon="pi pi-pencil"
            rounded
            outlined
            className="document-btn"
            onClick={() => handleEdit(rowData.key)}
          />
        )}
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          className="document-btn"
          onClick={() => handleDelete(rowData.key)}
        />
      </div>
    )
  }

  const [description, setDescription] = useState("")

  const getdocumentsitems = async candidate_id => {
    try {
      const response = await axios.get(
        `/api/v1/documents/?candidate_id=${candidate_id}`,
        {}
      )
      if (response.data) {
        const results = response?.data?.results?.map(item => ({
          key: item?.document_id?.toString(), // Unique key for TreeTable
          data: {
            certificate_name: allDocumentTypes.find(dt => dt.value === item?.document_type_name)?.id || item?.document_type_name,
            docSubject: item?.document_subject,
            attachments: item?.attachments,
            created_at: new Date(item?.created_at)?.toLocaleString(), // Format date if needed
          },
        }))
        setDocuments(results)
      }
    } catch (error) {
      console.error("Error fetching documents:", error)
    }
  }

  const attachmentBodyTemplate = rowData => {
    const attachments = rowData.data.attachments || []
    const maxFileNameLength = 20

    if (attachments.length === 0) {
      return <span>No attachments</span>
    }

    const truncateFileName = fileName => {
      if (fileName.length <= maxFileNameLength) return fileName
      const extension = fileName.split(".").pop()
      const nameWithoutExtension = fileName.slice(0, -(extension.length + 1))
      return `${nameWithoutExtension.slice(
        0,
        maxFileNameLength - extension.length - 3
      )}...${extension}`
    }

    return (
      <div className="flex flex-column gap-2">
        {attachments?.map(attachment => (
          <a
            key={attachment?.attachment_id}
            href={attachment?.file_path}
            download={attachment?.file_name}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
            title={`Download ${attachment?.file_name}`}
          >
            {truncateFileName(attachment?.file_name)}
          </a>
        ))}
      </div>
    )
  }

  const [addCities, setaddCities] = useState([])

  const [interviewdroptype, setinterviewdroptype] = useState([])

  const [loading, setLoading] = useState(false)

  const [customers, setCustomers] = useState([])

  const onSelectionChange = e => {
    setSelectedCustomers(e.value)
  }

  const transformedCandidates = selectedCustomers?.map(customer => ({
    label: `${customer?.first_name} ${customer?.last_name || ""}`,
    value: {
      candidate: customer?.candidate_id,
      first_name: customer?.first_name,
      last_name: customer?.last_name,
      designation: customer?.job_title,
      current_company: customer?.current_company,
      candidate_email: customer?.email,
      status: customer?.status,
    },
  }))

  const onRowReorder = e => {
    setCustomers(e.value)
  }

  // context menu starts

  const cm = useRef(null) // Reference for ContextMenu
  const [successAlert, setSuccessAlert] = useState(false)

  // view form notes starts
  const [isEditorVisible, setEditorVisible] = useState(false) // Manage editor visibility
  const [editorContent, setEditorContent] = useState("") // Manage editor content
  const [editIndex, setEditIndex] = useState(null)
  const [candidateNotes, setCandidateNotes] = useState([]) // Store notes in an array

  const handleAddNotes = () => {
    setEditorVisible(true)
    setEditorContent("")
    setEditIndex(null)
  }

  const fetchCandidateNotes = async candidate_id => {
    try {
      const response = await axios.get(
        `/api/v1/notes/?candidate_id=${candidate_id || id}`,
        {}
      )
      if (response?.data) {
        setCandidateNotes(response?.data?.results)
      }
    } catch (error) {
      console.error("Error fetching candidate notes:", error)
    }
  }

  // const handleSaveNotes = async () => {
  //   // if (editorContent.trim()) {
  //   //   const currentDateTime = new Date().toLocaleString() // Get current date and time
  //   //   const newNote = {
  //   //     content: editorContent,
  //   //     timestamp: `Saved on: ${currentDateTime}`,
  //   //     candidateName: "Note: Anup Gogoi - Senior Python developer - ATS", // Example candidate name, can be dynamic
  //   //   }

  //   //   if (editIndex !== null) {
  //   //     // Edit the existing note
  //   //     const updatedNotes = [...candidateNotes]
  //   //     updatedNotes[editIndex] = newNote // Update the specific note
  //   //     setCandidateNotes(updatedNotes)
  //   //     setEditIndex(null) // Reset editIndex after saving
  //   //   } else {
  //   //     // Add a new note in the array
  //   //     setCandidateNotes(prevNotes => [...prevNotes, newNote])
  //   //   }

  //   //   setEditorContent("") // Clear editor content after saving
  //   // }
  //   try {
  //     const isEditing = !!editIndex // or use `noteId`, depending on your state

  //     const url = isEditing
  //       ? `/api/v1/notes/${editIndex.note_id}/` // Adjust if your note ID is stored elsewhere
  //       : `/api/v1/notes/`

  //     const method = isEditing ? "put" : "post"

  //     const response = await axios({
  //       method,
  //       url,
  //       data: {
  //         notes: editorContent,
  //         candidate_id: selectedCustomers[0]?.candidate_id || id,
  //       },
  //     })

  //     if (response.status === 200 || response.status === 201) {
  //       setEditorVisible(false)
  //       setEditorContent("") // Clear editor content
  //       fetchCandidateNotes(selectedCustomers[0].candidate_id || id)
  //       setEditIndex(null)
  //     }
  //   } catch (error) {
  //     console.error("Error saving note:", error)
  //     // Optional: Show a toast for failure
  //     toast.current?.show({
  //       severity: "error",
  //       summary: "Save Failed",
  //       detail: "Could not save note. Please try again.",
  //     })
  //   }
  // }
  const handleSaveNotes = async () => {
  // Check if a candidate is selected
  const candidateId = selectedCustomers[0]?.candidate_id || id;
  if (!candidateId) {
    toast.current?.show({
      severity: "error",
      summary: "No Candidate Selected",
      detail: "Please select a candidate before saving a note.",
    });
    setVisibleViewRight(false);
    // Do NOT close the sidebar or clear the editor
    return;
  }

  try {
    const isEditing = !!editIndex;
    const url = isEditing
      ? `/api/v1/notes/${editIndex.note_id}/`
      : `/api/v1/notes/`;
    const method = isEditing ? "put" : "post";

    const response = await axios({
      method,
      url,
      data: {
        notes: editorContent,
        candidate_id: candidateId,
      },
    });

    if (response.status === 200 || response.status === 201) {
      setEditorVisible(false);
      setEditorContent("");
      fetchCandidateNotes(candidateId);
      setEditIndex(null);
    }
  } catch (error) {
    console.error("Error saving note:", error);
    toast.current?.show({
      severity: "error",
      summary: "Save Failed",
      detail: "Could not save note. Please try again.",
    });
  }
}

  

  const handleCancelNotes = () => {
    setEditorVisible(false)
    setEditorContent("") // Clear editor content
    setEditIndex(null) // Reset editIndex on cancel
  }

  const handleEditNote = note => {
    setEditorVisible(true)
    setEditorContent(note.notes) // Load the note content into the editor
    setEditIndex(note) // Set editIndex to edit the current note
  }

  const handleDeleteNote = note => {
    const noteId = note.note_id
    // ConfirmationAlert("Are you sure you want to delete this note?", "Delete", () => {
    axios
      .delete(`/api/v1/notes/${noteId}/`)
      .then(() => {
        toast.current?.show({
          severity: "success",
          summary: "Deleted",
          detail: "Note deleted successfully",
        })
        fetchCandidateNotes(selectedCustomers[0].candidate_id || id)
      })
      .catch(error => {
        console.error("Error deleting note:", error)
        // Optional: Show a toast for failure
        toast.current?.show({
          severity: "error",
          summary: "Delete Failed",
          detail: "Could not delete note. Please try again.",
        })
      })
    // })
  }

  // view form notes ends

  // view page ends

  const [showesitSelecticon, setshowesitSelecticon] = useState(false)
  const [showesitSelect, setshowesitSelect] = useState(true)
  const [showIconsSelect, setShowIconsSelect] = useState(false)

  const actSmsOptions = [
    {
      name: "Selected",
      code: "SMS-SE",
      icon: "pi pi-check",
    },
    {
      name: "Searched",
      code: "SMS-SR",
      icon: "pi pi-search",
    },
    {
      name: "All",
      code: "SMS-AL",
      icon: "pi pi-list",
    },
  ]
  // Fetch sub-types for Sub-Type Dropdown
  const fetchSubTypes = async scheduleId => {
    if (!scheduleId) return
    try {
      const response = await axios.get(
        `/api/v1/get-all-schedule-sub-type/?schedule_id=${scheduleId}`
      )
      const scheduleData = response.data?.results || []

      // Transform API data into flat list for Sub-Type Dropdown
      const transformedSubTypes = scheduleData?.map(schedule => ({
        name: schedule?.schedule_subtype || "Unnamed Sub-Type",
        code: schedule?.schedule_id || "",
      }))
      setSubTypeCall(transformedSubTypes)
      setScheduleSubtype(null)
    } catch (error) {
      console.error("Error fetching sub-types:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch sub-types. Using default options.",
        life: 3000,
      })
    }
  }

  const handleScheduleChange = e => {
    resetScheduleFields()
    const selectedOption = e.value
    setSelectedSchedule(selectedOption)

    // Fetch subtypes based on the selected schedule ID
    if (selectedOption.code) {
      fetchSubTypes(selectedOption.code)
    }

    // Open the dialog
    setScheduleCommonPopup(true)
  }

  // clear search starts

  const handleClearSearchCandidates = () => {
     setFilters({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    first_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    last_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile_phone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    current_company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    total_experience: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    city_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    availability_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    relocation: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    groups_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    resume: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    primary_skill_names: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created_at: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    street_address: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  }

  const cityOptions = [
    { name: "Hyderabad", code: "HYD" },
    { name: "Chennai", code: "CHN" },
    { name: "Mumbai", code: "MUM" },
    { name: "Bangalore", code: "BLR" },
    { name: "Delhi", code: "DEL" },
  ]
  // short form ends

  const [categories] = useState([
    {
      key: "0",
      label: "Skills",
      children: [
        {
          key: "0-0",
          label: "Frontend",
          children: [
            { key: "0-0-0", label: "React" },
            { key: "0-0-1", label: "Angular" },
            { key: "0-0-2", label: "Bootstrap" },
          ],
        },
        {
          key: "0-1",
          label: "Backend",
          children: [
            { key: "0-1-0", label: "Python" },
            { key: "0-1-1", label: "Java" },
            { key: "0-1-2", label: "C#" },
          ],
        },
        {
          key: "0-2",
          label: "QA",
          children: [
            { key: "0-2-0", label: "Manual" },
            { key: "0-2-1", label: "Automation" },
          ],
        },
      ],
    },
  ])

  // Export start

  const [importCsvIcons, setImportCsvIcons] = useState(false)

  // const headerBtn = (
  //   <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
  //     <Button
  //       className="csvbtn p-button"
  //       icon="pi pi-file"
  //       rounded
  //       onClick={() => exportCSVBtn(false)}
  //       data-pr-tooltip="CSV"
  //       tooltip="Export to CSV"
  //     />
  //     <Button
  //       className="xlsbtn p-button"
  //       icon="pi pi-file-excel"
  //       severity="success"
  //       rounded
  //       onClick={() =>
  //         exportExcel(
  //           selectedCustomers,
  //           filteredAdminstation,
  //           "candidates_data.xlsx"
  //         )
  //       }
  //       data-pr-tooltip="XLS"
  //       tooltip="Export to Excel"
  //     />
  //     <Button
  //       className="pdfbtn p-button me-2"
  //       icon="pi pi-file-pdf"
  //       severity="warning"
  //       rounded
  //       onClick={() =>
  //         exportPdf(
  //           selectedCustomers,
  //           filteredAdminstation,
  //           "candidates_data.pdf",
  //           dynamicColumns
  //         )
  //       }
  //       // disabled={customers.length === 0}
  //       data-pr-tooltip="PDF"
  //       tooltip="Export to Pdf"
  //     />
  //   </div>
  // )

  // Export code start
  const exportCSVBtn = selectionOnly => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly })
    } else {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "DataTable reference not found.",
      })
    }
  }

  // Function to export to PDF
  const exportPdfBtn = selectionOnly => {
    const dataToExport = selectionOnly
      ? selectedCustomers
      : filteredAdminstation
    if (dataToExport.length === 0) {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "No data available for export.",
      })
      return
    }

    const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a3",
  });
    let exportColumns = []
    let exportData = []

    if (type === "task-list") {
      exportColumns = [
        "Event Type",
        "Event Sub Type",
        "Event Time",
        "Start Date Time",
        "End Date Time",
        "Event Priority",
        "Subject",
        "Status",
        "Created By",
      ]

      exportData = dataToExport?.map(row => [
        row?.event_type || "-",
        row?.event_sub_type || "-",
        row?.event_time
          ? moment(row?.event_time).format("DD/MM/YYYY HH:mm")
          : "-",
        row?.startDateTime
          ? moment(row?.startDateTime).format("DD/MM/YYYY HH:mm")
          : "-",
        row?.endDateTime
          ? moment(row?.endDateTime).format("DD/MM/YYYY HH:mm")
          : "-",
        row?.event_priority || "-",
        row?.subject || "-",
        row?.status || "-",
        row?.created_by_name || "-",
      ])
    } else if (type === "activity_log") {
      exportColumns = [
        "Event Type",
        "Event Sub Type",
        "Event Priority",
        "Subject",
        "Status",
        "Start Date",
        "End Date",
        "Created By",
      ]

      exportData = dataToExport?.map(row => [
        row?.event_type || "-",
        row?.event_sub_type || "-",
        row?.event_priority || "-",
        row?.subject || "-",
        row?.status || "-",
        row?.start_date ? moment(row.start_date).format("DD/MM/YYYY") : "-",
        row?.end_date ? moment(row.end_date).format("DD/MM/YYYY") : "-",
        row?.created_by_name || "-",
      ])
    } else {
      exportColumns = [
        "First Name",
        "Last Name",
        "Job Title",
        "Email",
        "Phone",
        "Company Name",
        "Resume",
        "Total Experience",
        "Primary Skills",
        // "Address",
        "Status",
        "Employment Type",
        "Current Salary",
        "Expected Salary",
        "Created At",
      ]

      exportData = dataToExport?.map(row => [
        row?.first_name || "-",
        row?.last_name || "-",
        row?.job_title || "-",
        row?.email || "-",
        row?.mobile_phone || "-",
        row?.current_company || "-",
        row?.resume || "-",
        row?.total_experience || "-",
        row?.primary_skill_names || "-",
        // row.secondary_skill_names || "-",
        // row.other_skill_names || "-",
        // row.street_address + ", " + row.city + ", " + row.state + ", " + row.country || "-",
        row?.status || "-",
        row?.employee_type || "-",
        row?.current_salary || "-",
        row?.expected_salary || "-",

        row?.created_at
          ? moment(row.created_at).format("DD/MM/YYYY HH:mm")
          : "-",
      ])
    }

    doc.autoTable({
      head: [exportColumns],
      body: exportData,
      startY: 30,
      styles: {
        fontSize: 8,
        cellPadding: 3,
        overflow: "linebreak",
        cellWidth: "auto", // Wrap content properly
      },
      headStyles: {
      fillColor: [0, 180, 180],
      textColor: "#fff",
      fontStyle: "bold",
    },
      theme: "grid",
      margin: { top: 10, left: 5, right: 5 },
       didDrawPage: function (data) {
      doc.setFontSize(14);
      doc.text("Candidates Data", data.settings.margin.left, 20);
    },
    })

    doc.save("candidates_data.pdf")
  }
  // Function to save the Excel file
  const saveAsExcelFile = (buffer, fileName) => {
    const data = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    saveAs(data, `${fileName}_export_${new Date().getTime()}.xlsx`)
  }
  // Function to export to Excel
  const exportExcelBtn = selectionOnly => {
    const dataToExport = selectionOnly
      ? selectedCustomers
      : filteredAdminstation
    if (dataToExport.length === 0) {
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: "No data available for export.",
      })
      return
    }

    let exportData = []

    if (type === "task-list") {
      exportData = dataToExport?.map(row => ({
        "Event Type": row?.event_type || "-",
        "Event Sub Type": row?.event_sub_type || "-",
        "Event Time": row?.event_time
          ? moment(row?.event_time).format("DD/MM/YYYY HH:mm")
          : "-",
        "Start Date ": row?.start_date
          ? moment(row?.start_date).format("DD/MM/YYYY")
          : "-",
        "End Date ": row?.end_date
          ? moment(row?.end_date).format("DD/MM/YYYY")
          : "-",
        "Event Priority": row?.event_priority || "-",
        Subject: row?.subject || "-",
        Status: row?.status || "-",
        "Created By": row?.created_by_name || "-",
      }))
    } else if (type === "activity_log") {
      exportData = dataToExport?.map(row => ({
        "Event Type": row?.event_type || "-",
        "Event Sub Type": row?.event_sub_type || "-",
        "Event Priority": row?.event_priority || "-",
        Subject: row?.subject || "-",
        Status: row?.status || "-",
        "Start Date": row?.start_date
          ? moment(row?.start_date).format("DD/MM/YYYY")
          : "-",
        "End Date": row?.end_date
          ? moment(row?.end_date).format("DD/MM/YYYY")
          : "-",
        "Created By": row?.created_by_name || "-",
      }))
    } else {
      exportData = dataToExport?.map(row => ({
        "First Name": row?.first_name || "-",
        "Last Name": row?.last_name || "-",
        "Job Title": row?.job_title || "-",
        Email: row?.email || "-",
        Phone: row?.mobile_phone || "-",
        "Company Name": row?.current_company || "-",
        Resume: row?.resume || "-",
        "Total Experience": row?.total_experience || "-",
        "Primary Skills": row?.primary_skill_names || "-",
        Status: row?.status || "-",
        "Employment Type": row?.employee_type || "-",
        "Current Salary": row?.current_salary || "-",
        "Expected Salary": row?.expected_salary || "-",
        "Created At": row?.created_at
          ? moment(row?.created_at).format("DD/MM/YYYY HH:mm")
          : "-",
      }))
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData)
    const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] }
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })
    saveAsExcelFile(excelBuffer, "candidates_data")
  }

  const headerBtn = (
    <div className="flex align-items-center justify-content-end gap-1 actionitem-import">
      {selectedCustomers.length > 0 ? (
        <>
          <Button
            className="csvbtn p-button"
            icon="pi pi-file"
            rounded
            onClick={() => exportCSVBtn(true)}
            tooltip="Export Selected to CSV"
          />
          <Button
            className="xlsbtn p-button"
            icon="pi pi-file-excel"
            severity="success"
            rounded
            onClick={() => exportExcelBtn(true)}
            tooltip="Export Selected to Excel"
          />
          <Button
            className="pdfbtn p-button me-2"
            icon="pi pi-file-pdf"
            severity="warning"
            rounded
            onClick={() => exportPdfBtn(true)}
            tooltip="Export Selected to PDF"
          />
        </>
      ) : (
        <>
          <Button
            className="csvbtn p-button"
            icon="pi pi-file"
            rounded
            onClick={() => exportCSVBtn(false)}
            tooltip="Export to CSV"
          />
          <Button
            className="xlsbtn p-button"
            icon="pi pi-file-excel"
            severity="success"
            rounded
            onClick={() => exportExcelBtn(false)}
            tooltip="Export to Excel"
          />
          <Button
            className="pdfbtn p-button me-2"
            icon="pi pi-file-pdf"
            severity="warning"
            rounded
            onClick={() => exportPdfBtn(false)}
            disabled={filteredAdminstation.length === 0}
            tooltip="Export to PDF"
          />
        </>
      )}
    </div>
  )
  const [subtypeget, setsubtypeget] = useState(null)

  const [popTextares, setPopTextares] = useState("")

  const jobStatusDrop = [
    { name: "Open", value: "Open" },
    { name: "Closed", value: "Closed" },
    { name: "On Hold", value: "On Hold" },
  ]

  const priorityValue = [
    { name: "Low", value: "low" },
    { name: "Medium", value: "medium" },
    { name: "High", value: "high" },
  ]

  const handlePopupCheckbox2 = e => {
    setSchedulePopchecked2(e.checked)
  }

  const [userid, setUserid] = useState(["Harish"])
  const customChip = item => {
    return (
      <div>
        <span>{item}</span>
        {/* <i className="pi pi-user-plus"></i> */}
      </div>
    )
  }
  const [popchecked, setPopchecked] = useState(false)
  const handlePopupCheckbox = e => {
    setPopchecked(e.checked)
  }
  // interview popup ends

  // Create a Candidate start

  const navigate = useNavigate()

  const [notes1, setNotes1] = useState()

  // import resume
  const toast = useRef(null)

  // const customBase64Uploader = async event => {
  //   try {
  //     // Access the uploaded file
  //     const file = event.files[0]

  //     // Redirect the user immediately after file submission
  //     navigate("/candidate-editform")

  //     // Optional: Process the file in the background
  //     const blob = await fetch(file.objectURL).then(r => r.blob())
  //     const reader = new FileReader()
  //     reader.readAsDataURL(blob)

  //     reader.onloadend = function () {
  //       const base64data = reader.result // Base64 encoded data
  //     }
  //   } catch (error) {
  //     console.error("Error during file upload:", error)
  //   }
  // }

  const customBase64Uploader1 = async event => {
    setLoading(true) // Start loading animation

    try {
      const file = event.files[0]
      if (!file) {
        throw new Error("No file selected")
      }

      // Validate file type and size
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ]
      const maxFileSize = 5 * 1024 * 1024 // 5MB

      if (!allowedTypes.includes(file.type)) {
        throw new Error("Invalid file type. Please upload PDF or DOC files.")
      }

      if (file.size > maxFileSize) {
        throw new Error("File size exceeds 5MB limit.")
      }

      const formData = new FormData()
      formData.append("resume_files", file) // Use the key 'resume_files'

      const response = await axios.post(
        resume_import + "api/resume/",
        formData, 
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     // Authorization: `Bearer ${token}`,
        //   },
        //   timeout: 30000, // 30 seconds timeout
        // }
      )

      // Convert to base64
      const base64Data = await getBase64(file)

      const resumeFile = {
        name: file.name,
        type: file.type,
        size: file.size,
        base64: base64Data,
      }
      // console.log("resumeFile", resumeFile);
      switch (response.status) {
        case 200:
          navigate("/uploadresumeform", {
            state: { resumeData: response.data, resumeFile },
          })
          break
        default:
          throw new Error(`Unexpected response status: ${response.status}`)
      }
    } catch (error) {
      console.error("Error uploading file:", error)
      let errorMessage = "An unexpected error occurred"

      if (error.response) {
        switch (error.response.status) {
          case 400:
            errorMessage = "Invalid request. Please check your file."
            break
          case 401:
            errorMessage = "Authentication failed. Please log in again."
            break
          case 403:
            errorMessage = "You do not have permission to upload."
            break
          case 413:
            errorMessage = "File is too large. Maximum 5MB allowed."
            break
          default:
            errorMessage =
              error.response.data.message ||
              `Server responded with status ${error.response.status}`
        }
      } else if (error.request) {
        errorMessage = "No response received from server."
      } else {
        errorMessage = error.message
      }
      navigate("/uploadresumeform", { state: { error: errorMessage } })
    } finally {
      setLoading(false) // End loading animation
    }
  }


  return (
    <React.Fragment>
      <div className="page-content allact-tabs">
        {!dontShowOtherUI && (
          <Container fluid={true}>
            {isLoading && <LoadingSpinner />}
            <div className="page-title-box actjobbread">
              {/* Action items start */}
              <Row className="justify-content-between ac-items">
                <Col xxl={10} xl={12} lg={12} md={12} sm={12}>
                  <span className="addcan-ac">
                  <Dropdown
                    value={selectedCandidateStatus}
                    options={candidateStatusOptions}
                    onChange={e => setSelectedCandidateStatus(e.value)}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Status"
                    className="me-2"
                    style={{ minWidth: 180, verticalAlign: "middle" }}
                  />
                    {selectedCustomers.length > 0 && (
                      <span className="action-icons me-2">
                        <button
                          type="button"
                          className="btn btn-secondary import-res-btn me-1 md:w-8rem"
                        >
                          <i className="pi pi-user"></i>{" "}
                          {selectedCustomers.length} Selected
                        </button>

                        <span className="icons-ac">
                          {selectedCustomers.length === 1 && (
                            <>
                              {viewPermission && (
                                <>
                                  <Tooltip
                                    target=".view"
                                    content="View"
                                    position="bottom"
                                    style={{ marginTop: "5px" }}
                                  />

                                  <button
                                    type="button"
                                    class="btn btn-secondary icons-btn ms-1 view"
                                    onClick={() => {
                                      getdocumentsitems(
                                        selectedCustomers[0].candidate_id
                                      )
                                      geteditvaluescondidates(
                                        selectedCustomers[0].candidate_id
                                      )
                                      getAllActiveReceived(
                                        selectedCustomers[0].candidate_id
                                      ) //Pipeline API
                                      getAllActiveActivies(
                                        selectedCustomers[0].candidate_id
                                      ) //Activities API
                                      fetchCandidateNotes(
                                        selectedCustomers[0].candidate_id
                                      ) //Notes API
                                      getAllHistory(
                                        selectedCustomers[0].candidate_id
                                      ) //History API
                                      setVisibleViewRight(true)
                                      setCandId(
                                        selectedCustomers[0].candidate_id
                                      )
                                    }}
                                  >
                                    <i className="pi pi-eye"></i>
                                  </button>
                                </>
                              )}

                              {editPermission && (
                                <>
                                  <Tooltip
                                    target=".edit"
                                    content="Edit"
                                    position="top"
                                    style={{ marginBottom: "5px" }}
                                  />

                                  <Link
                                    to={`/candidate-editform?candidate_id=${selectedCustomers[0]?.candidate_id}`}
                                    className="p-link"
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-secondary icons-btn ms-1 edit"
                                    >
                                      <i className="pi pi-pencil"></i>
                                    </button>
                                  </Link>
                                </>
                              )}
                            </>
                          )}

                          <Tooltip
                            target=".delete"
                            content="Delete"
                            position="bottom"
                            style={{ marginTop: "5px" }}
                          />
                          {deletePermission && (
                            <>
                              <button
                                type="button"
                                class="btn btn-secondary icons-btn ms-1 delete"
                                onClick={() =>
                                  handleDeleteCandidate(selectedCustomers)
                                }
                                // onClick={() => alert("Are you sure?")}
                              >
                                <i className="pi pi-trash"></i>
                              </button>
                            </>
                          )}

                          <Tooltip
                            target=".archive-btn"
                            content={
                              param === "archived_only=true"
                                ? "Unarchive"
                                : "Archive"
                            }
                            position="top"
                            style={{ marginBottom: "5px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-secondary icons-btn ms-1 archive-btn"
                            onClick={() => archiveCandidate(selectedCustomers)}
                          >
                            {param === "archived_only=true" ? (
                              <i className="pi pi-replay"></i>
                            ) : (
                              <i className="pi pi-check-circle"></i>
                            )}
                          </button>
                        </span>
                        <Modal
                          size="md"
                          show={smShow}
                          onHide={() => setSmShow(false)}
                          className="text-center"
                        >
                          <Modal.Header closeButton>
                            <h1 className="modal-title fs-5">Archive</h1>
                          </Modal.Header>
                          <div className="text-center m-3"></div>
                          <h4 className="text-center">
                            Are you sure you want to archive?
                          </h4>
                          <div className="text-center m-3">
                            <Button
                              className="btn btn-primary m-1"
                              onClick={() => setSmShow(false)}
                            >
                              Cancel
                            </Button>
                            <button
                              className="btn btn-danger m-1"
                              onClick={archivedHandler}
                            >
                              Archive
                            </button>
                          </div>
                        </Modal>

                        <Modal
                          size="md"
                          show={smShowun}
                          onHide={() => setSmShowun(false)}
                          className="text-center"
                        >
                          <Modal.Header closeButton>
                            <h1 className="modal-title fs-5">Unarchive</h1>
                          </Modal.Header>
                          <div className="text-center m-3"></div>
                          <h4 className="text-center">
                            Are you sure you want to unarchive?
                          </h4>
                          <div className="text-center m-3">
                            <Button
                              className="btn btn-primary m-1"
                              onClick={() => setSmShowun(false)}
                            >
                              Cancel
                            </Button>
                            <button
                              className="btn btn-danger m-1"
                              onClick={unarchivedHandler}
                            >
                              Unarchive
                            </button>
                          </div>
                        </Modal>
                      </span>
                      
                    )}
                    <>
        {selectedCandidateStatus === "Active" ? (
          <>
            {addPermission && selectedCustomers.length === 0 && (
              <button
                type="button"
                className="btn btn-secondary import-res-btn md:w-10rem me-1"
                onClick={() => {
                  reset()
                  dispatch(setCandidateSidebarVisible(true));
                  setHaveImagePan(false)
                  setSelectedNodeKey([])
                  setselectedgroupKey([])
                  setPrimarySkills()
                }}
              >
                <i className="pi pi-user me-1"></i> Add a Candidate
              </button>
            )}
            <span className="drop-ac">
              <EmailAC
                ref={emailCandidateRef}
                selectedData={selectedCustomers}
              />
              <CascadeSelect
                onChange={handleScheduleChange}
                options={actScheduleOptions}
                optionLabel="name"
                optionGroupLabel="name"
                className="md:w-10rem me-1"
                optionGroupChildren={["subItems", "subItems"]}
                breakpoint="767px"
                placeholder="Schedule"
              />
              <SubmitCandidatetoJob
                ref={submitCandidateRef}
                selectedCandidates={selectedCustomers}
              />
              <LinkJobs
                ref={moreACContactsRef}
                selectedCandidates={transformedCandidates}
                linkJobs={linkJobs}
                refreshCandidates={refreshCandidates}
                clearSelectedCandidates={() => setSelectedCustomers([])}
              />
            </span>
          </>
        ) : (
          // For non-active status, show only More dropdown
          <span className="drop-ac">
            <LinkJobs
              ref={moreACContactsRef}
              selectedCandidates={transformedCandidates}
              linkJobs={linkJobs}
              refreshCandidates={refreshCandidates}
              clearSelectedCandidates={() => setSelectedCustomers([])}
              onlyChangeStatus // You can use this prop to control rendering inside LinkJobs if needed
            />
          </span>
        )}
      </>
                  </span>
                </Col>

                <Col xxl={2} xl={12} lg={12} sm={12}>
                  <div className="clr-icons">
                    {/* {selectedCustomers.length > 0 ? ( */}
                    <NotesCandidate
                      ref={notesCandidateRef}
                      selectedCustomers={selectedCustomers}
                    />
                    {/* ) : (
                    <Notes />
                  )} */}

                    {/* <div className="clr-icons">
                    <Toast ref={toast} />
                    <FileUpload
                      mode="basic"
                      name="demo[]"
                      url="/api/upload"
                      accept="image/*"
                      maxFileSize={1000000}
                      onUpload={onUpload}
                      chooseLabel="" // Remove text
                      chooseOptions={{
                        className: "p-button p-button-icon-only mr-1 icons-btn",
                        icon: "pi pi-file-import",
                        iconOnly: true,
                      }}
                    />
                  </div> */}

                    {/* <FileUpload mode="basic" name="demo[]" url="/api/upload" accept="image/*"  uploadHandler={customBase64Uploader} /> */}
                    {/* {loading ? (
                      <div className="action-items">
                        <ClipLoader color={"#007bff"} loading={loading} />
                        <span
                          style={{ fontSize: "0.875rem", color: "#007bff" }}
                        >
                          Uploading...
                        </span>
                      </div>
                    ) : (
                      <>
                        <Tooltip
                          target=".import"
                          content="Export"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />
                        <FileUpload
                          mode="basic"
                          accept="/"
                          name="demo[]"
                          customUpload
                          data-pr-tooltip="Import Resume"
                          tooltip="Import Resume"
                          auto
                          uploadHandler={customBase64Uploader1}
                          chooseLabel=""
                          chooseOptions={{
                            className:
                              "p-button p-button-icon-only mr-1 icons-btn import",
                            icon: "pi pi-file-import",
                            iconOnly: true,
                          }}
                        />
                      </>
                    )} */}
                    {loading ? (
                      <div className="action-items">
                        <ClipLoader color={"#007bff"} loading={loading} />
                        <span
                          style={{ fontSize: "0.875rem", color: "#007bff" }}
                        >
                          Uploading...
                        </span>
                      </div>
                    ) : (
                      <>
                        <Tooltip
                          target=".import"
                          content="Import Resume"
                          position="top"
                          style={{ marginBottom: "5px" }}
                        />
                        <FileUpload
                          ref={fileUploadRef} // Attach ref to FileUpload
                          mode="basic"
                          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                          name="demo[]"
                          customUpload
                          data-pr-tooltip="Import Resume"
                          tooltip="Import Resume"
                          auto
                          uploadHandler={customBase64Uploader}
                          chooseLabel=""
                          chooseOptions={{
                            className:
                              "p-button p-button-icon-only mr-1 icons-btn import",
                            icon: "pi pi-file-import",
                            iconOnly: true,
                          }}
                        />
                      </>
                    )}

                    <Tooltip
                      target=".export"
                      content="Export"
                      position="top"
                      style={{ marginBottom: "5px" }}
                    />

                    <button
                      type="button"
                      className="btn btn-secondary icons-btn me-1 export"
                      onClick={() => setImportCsvIcons(!importCsvIcons)}
                      data-pr-tooltip="Export"
                      tooltip="Export"
                    >
                      <i className="pi pi-file-export"></i>
                    </button>

                    {importCsvIcons && <span>{headerBtn}</span>}

                    <Tooltip
                      target=".clear"
                      content="Clear Search"
                      position="bottom"
                      style={{ marginTop: "5px" }}
                    />

                    <button
                      type="button"
                      className="btn btn-secondary icons-btn clear"
                      onClick={handleClearSearchCandidates}
                      Tooltip="Clear Search"
                    >
                      <i className="pi pi-sync"></i>
                    </button>

                    <button
                      type="button"
                      className="mainbtn btn btn-secondary import-res-btn d-none"
                      tooltip="Merge"
                      tooltipOptions={{ position: "bottom" }}
                    >
                      <i className="pi pi-print"></i>
                    </button>
                  </div>
                </Col>
              </Row>
              {/* Action items end */}

              {/* candidate table starts */}
              <Row>
                <Col sm={12}>
                  <React.Fragment>
                    <section className="">
                      {/* Toast for notifications */}
                      <Toast ref={toast} />

                      {/* ContextMenu for right-click actions */}
                      <ContextMenu
                        model={menuModel}
                        ref={contextMenu}
                        onHide={() => setSelectedCandidate(null)}
                      />

                      <div className="card1 mt-4 mb-4 actjobsumtable">
                      {loading1 ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
      <ProgressSpinner />
    </div>
  ): type === "activity_log" ? (
                          <DataTable
                            ref={dt}
                            value={filterData(filteredAdminstation)}
                            first={first}
                            rows={rows}
                            totalRecords={totalRecords}
                            onPage={onPageChange}
                            loading={loading}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            rowsPerPageOptions={[10, 20, 50, totalRecords]}
                            dataKey="id"
                            filters={filtersActivityLog}
                            filterDisplay="row"
                            onFilter={e => setFiltersActivityLog(e.filters)}
                            scrollable
                            emptyMessage="No Activity Log found."
                            selectionMode="checkbox"
                            selection={selectedCustomers}
                            onSelectionChange={onSelectionChange}
                            reorderableRows
                            onRowReorder={onRowReorder}
                            rowGroupMode="rowspan"
                            rowClassName="row-bottom-color"
                            editMode="cell"
                            onContextMenuSelectionChange={e =>
                              setSelectedCandidate(e.value)
                            }
                            contextMenuSelection={selectedCandidate}
                            onContextMenu={e => {
                              contextMenu.current?.show(e.originalEvent)
                              setSelectedCandidate(e.data)
                            }}
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />

                            <Column
                              field="first_name"
                              sortable
                              header="First Name"
                              frozen
                              filter
                              filterPlaceholder="Search by first name"
                              style={{ minWidth: "12rem" }}
                              editor={textEditor}
                              onCellEditComplete={onCellEditComplete}
                            />
                            <Column
                              field="last_name"
                              sortable
                              header="Last Name"
                              filter
                              filterPlaceholder="Search by last name"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="email"
                              sortable
                              header="Email"
                              filter
                              filterPlaceholder="Search by email"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="job_title"
                              sortable
                              header="Job Title"
                              filter
                              filterPlaceholder="Search by job title"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="category_name"
                              sortable
                              header="Categories"
                              filter
                              filterPlaceholder="Search by categories"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="groups_name"
                              sortable
                              header="Groups"
                              filter
                              filterPlaceholder="Search by groups"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="description"
                              sortable
                              header="Description"
                              filter
                              filterPlaceholder="Search by description"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="event_type"
                              sortable
                              header="Event Type"
                              filter
                              filterPlaceholder="Search by event type"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="event_sub_type"
                              sortable
                              header="Event Sub Type"
                              filter
                              filterPlaceholder="Search by event sub type"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="start_date"
                              sortable
                              header="Start Date"
                              filter
                              filterPlaceholder="Search by start date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.start_date
                                  ? moment(rowData.start_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="end_date"
                              sortable
                              header="End Date"
                              filter
                              filterPlaceholder="Search by end date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.end_date
                                  ? moment(rowData.end_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="subject"
                              sortable
                              header="Subject"
                              filter
                              filterPlaceholder="Search by subject"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="status"
                              sortable
                              header="Status"
                              filter
                              filterPlaceholder="Search by status"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="created_at"
                              sortable
                              header="Created At"
                              filter
                              filterPlaceholder="Search by created date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.created_at
                                  ? moment(rowData.created_at).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="created_by_name"
                              sortable
                              header="Created By"
                              filter
                              filterPlaceholder="Search by creator"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="updated_at"
                              sortable
                              header="Updated At"
                              filter
                              filterPlaceholder="Search by updated date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.updated_at
                                  ? moment(rowData.updated_at).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                          </DataTable>
                        ) : type === "task-list" ? (
                          <DataTable
                            ref={dt}
                            value={filterData(filteredAdminstation)}
                            first={first}
                            rows={rows}
                            totalRecords={totalRecords}
                            onPage={onPageChange}
                            loading={loading}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            rowsPerPageOptions={[10, 20, 50, totalRecords]}
                            dataKey="id"
                            filters={filtersActivityLog}
                            filterDisplay="row"
                            onFilter={e => setFiltersActivityLog(e.filters)}
                            scrollable
                            emptyMessage="No task list found."
                            selectionMode="checkbox"
                            selection={selectedCustomers}
                            onSelectionChange={onSelectionChange}
                            reorderableRows
                            onRowReorder={onRowReorder}
                            rowGroupMode="rowspan"
                            rowClassName="row-bottom-color"
                            editMode="cell"
                            onContextMenuSelectionChange={e =>
                              setSelectedCandidate(e.value)
                            }
                            contextMenuSelection={selectedCandidate}
                            onContextMenu={e => {
                              contextMenu.current?.show(e.originalEvent)
                              setSelectedCandidate(e.data)
                            }}
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />

                            <Column
                              field="first_name"
                              sortable
                              header="First Name"
                              frozen
                              filter
                              filterPlaceholder="Search by first name"
                              style={{ minWidth: "12rem" }}
                              editor={textEditor}
                              onCellEditComplete={onCellEditComplete}
                            />
                            <Column
                              field="last_name"
                              sortable
                              header="Last Name"
                              filter
                              filterPlaceholder="Search by last name"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="email"
                              sortable
                              header="Email"
                              filter
                              filterPlaceholder="Search by email"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="job_title"
                              sortable
                              header="Job Title"
                              filter
                              filterPlaceholder="Search by job title"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="category_name"
                              sortable
                              header="Categories"
                              filter
                              filterPlaceholder="Search by categories"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="groups_name"
                              sortable
                              header="Groups"
                              filter
                              filterPlaceholder="Search by groups"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="description"
                              sortable
                              header="Description"
                              filter
                              filterPlaceholder="Search by description"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="event_type"
                              sortable
                              header="Event Type"
                              filter
                              filterPlaceholder="Search by event type"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="event_sub_type"
                              sortable
                              header="Event Sub Type"
                              filter
                              filterPlaceholder="Search by event sub type"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="start_date"
                              sortable
                              header="Start Date"
                              filter
                              filterPlaceholder="Search by start date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.start_date
                                  ? moment(rowData.start_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="end_date"
                              sortable
                              header="End Date"
                              filter
                              filterPlaceholder="Search by end date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.end_date
                                  ? moment(rowData.end_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="subject"
                              sortable
                              header="Subject"
                              filter
                              filterPlaceholder="Search by subject"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="status"
                              sortable
                              header="Status"
                              filter
                              filterPlaceholder="Search by status"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="created_at"
                              sortable
                              header="Created At"
                              filter
                              filterPlaceholder="Search by created date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.created_at
                                  ? moment(rowData.created_at).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                            <Column
                              field="created_by_name"
                              sortable
                              header="Created By"
                              filter
                              filterPlaceholder="Search by creator"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="updated_at"
                              sortable
                              header="Updated At"
                              filter
                              filterPlaceholder="Search by updated date"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.updated_at
                                  ? moment(rowData.updated_at).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                            />
                          </DataTable>
                        ) : (
                          <DataTable
                            ref={dt}
                            value={filterData(filteredAdminstation)}
                            first={first}
                            rows={rows}
                            totalRecords={totalRecords}
                            onPage={onPageChange}
                            loading={loading}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"
                            dataKey="candidate_id"
                            filters={filters}
                            filterDisplay="row"
                            scrollable
                            emptyMessage="No candidates found."
                            selectionMode="checkbox"
                            selection={selectedCustomers}
                            onSelectionChange={onSelectionChange}
                            reorderableRows
                            onRowReorder={onRowReorder}
                            rowGroupMode="rowspan"
                            rowClassName="row-bottom-color" // Apply custom row style
                            editMode="cell"
                            onContextMenuSelectionChange={e =>
                              setSelectedCandidate(e.value)
                            }
                            contextMenuSelection={selectedCandidate}
                            onContextMenu={e => {
                              contextMenu.current?.show(e.originalEvent)
                              setSelectedCandidate(e.data)
                            }}
                            resizableColumns // Enable resizable columns
                            columnResizeMode="expand" // Choose between "fit" or "expand"
                          >
                            <Column
                              selectionMode="multiple"
                              headerStyle={{ width: "3em" }}
                            />
                            <Column
                              field="first_name"
                              sortable
                              header="First Name"
                              frozen
                              filter
                              filterPlaceholder="Search by first name"
                              style={{ minWidth: "12rem" }}
                              editor={textEditor}
                              onCellEditComplete={onCellEditComplete}
                            />
                            <Column
                              field="last_name"
                              sortable
                              header="Last Name"
                              filter
                              filterPlaceholder="Search by last name"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="job_title"
                              sortable
                              header="Job Title"
                              filter
                              filterPlaceholder="Search by job title"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="email"
                              sortable
                              header="Email"
                              filter
                              filterPlaceholder="Search by email"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="mobile_phone"
                              sortable
                              header="Mobile Phone"
                              filter
                              filterPlaceholder="Search by phone"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="current_company"
                              sortable
                              header="Company"
                              filter
                              filterPlaceholder="Search by company"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="total_experience"
                              sortable
                              header="Years of Experience"
                              filter
                              filterPlaceholder="Search by experience"
                              style={{ minWidth: "15rem" }}
                            />
                            <Column
                              field="street_address"
                              header="Address"
                              sortable
                              filter
                              filterPlaceholder="Search by address"
                              style={{
                                minWidth: "18rem",
                                padding: "0.5rem 1rem",
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                              body={rowData => {
                                const normalize = val => {
                                  if (Array.isArray(val)) {
                                    if (val.length === 1)
                                      return normalize(val[0])
                                    return val?.map(normalize).join(", ")
                                  }
                                  if (typeof val === "object" && val !== null) {
                                    const values =
                                      Object?.values(val)?.map(normalize)
                                    return values?.join(", ")
                                  }
                                  return val !== undefined && val !== null
                                    ? String(val)
                                    : ""
                                }
                                const parts = [
                                  normalize(rowData.street_address),
                                  normalize(rowData.street_address_line_2),
                                  normalize(rowData.city_name),
                                  normalize(rowData.state_name),
                                  normalize(rowData.country_name),
                                  normalize(rowData.pincode),
                                ].filter(
                                  part =>
                                    part &&
                                    part !== "[object Object]" &&
                                    part !== "undefined" &&
                                    part !== "null"
                                )
                                return parts.length ? parts.join(", ") : "-"
                              }}
                              filterFunction={(value, filter, rowData) => {
                                // Normalize and join all address parts for filtering
                                const normalize = val => {
                                  if (Array.isArray(val)) {
                                    if (val.length === 1)
                                      return normalize(val[0])
                                    return val.map(normalize).join(", ")
                                  }
                                  if (typeof val === "object" && val !== null) {
                                    const values =
                                      Object?.values(val)?.map(normalize)
                                    return values?.join(", ")
                                  }
                                  return val !== undefined && val !== null
                                    ? String(val)
                                    : ""
                                }
                                const addressString = [
                                  normalize(rowData.street_address),
                                  normalize(rowData.street_address_line_2),
                                  normalize(rowData.city_name),
                                  normalize(rowData.state_name),
                                  normalize(rowData.country_name),
                                  normalize(rowData.pincode),
                                ]
                                  .filter(
                                    part =>
                                      part &&
                                      part !== "[object Object]" &&
                                      part !== "undefined" &&
                                      part !== "null"
                                  )
                                  .join(", ")
                                  .toLowerCase()

                                return addressString.includes(
                                  (filter || "").toLowerCase()
                                )
                              }}
                            />
                            <Column
                              field="status"
                              sortable
                              header="Status"
                              filter
                              filterPlaceholder="Search by Status"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="relocation"
                              sortable
                              header="Relocation"
                              filter
                              filterPlaceholder="Search by relocation"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.relocation ? "Yes" : "No"
                              }
                            />
                            <Column
                              field="category_name"
                              sortable
                              header="Categories"
                              filter
                              filterPlaceholder="Search by groups"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="groups_name"
                              header="Groups"
                              sortable
                              filter
                              filterPlaceholder="Search by groups"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="primary_skill_names"
                              header="Primary Skills"
                              sortable
                              filter
                              filterPlaceholder="Search by skills"
                              style={{
                                minWidth: "20rem",
                                maxWidth: "20rem", // Fixed width
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                              }}
                              body={rowData => (
                                <span
                                  className="primary-skills-text"
                                  style={{
                                    display: "inline-block",
                                    width: "100%",
                                    textOverflow: expandedRows[
                                      rowData.candidate_id
                                    ]
                                      ? "clip"
                                      : "ellipsis",
                                    overflow: expandedRows[rowData.candidate_id]
                                      ? "visible"
                                      : "hidden",
                                    whiteSpace: expandedRows[
                                      rowData.candidate_id
                                    ]
                                      ? "normal"
                                      : "nowrap",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    toggleExpand(rowData.candidate_id)
                                  }
                                  title={
                                    rowData.primary_skill_names || "No skills"
                                  } // Fallback for accessibility
                                >
                                  {rowData.primary_skill_names || "No skills"}
                                </span>
                              )}
                            />
                            <Column
                              field="created_at"
                              body={rowData =>
                                rowData.created_at
                                  ? moment(rowData.created_at).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                              header="Create Date"
                              sortable
                              filter
                              filterPlaceholder="Search by create date"
                              style={{ minWidth: "12rem" }}
                            />
                            {/* <Column field="EditDate" header="Edit Date" sortable filter filterPlaceholder="Search by edit date" style={{ minWidth: '12rem' }} /> */}
                            <Column
                              field="created_by_name"
                              header="Created By"
                              sortable
                              filter
                              filterPlaceholder="Search by creator"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="availability_date"
                              body={rowData =>
                                rowData.availability_date
                                  ? moment(rowData.availability_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  : ""
                              }
                              header="Availability Date"
                              sortable
                              filter
                              filterPlaceholder="Search by date"
                              style={{ minWidth: "12rem" }}
                            />
                            {/* <Column field="resume" header="Resume Attachment" sortable filterPlaceholder="Search by attachment" style={{ minWidth: '12rem' }} /> */}
                          </DataTable>
                        )}
                      </div>
                    </section>
                  </React.Fragment>
                </Col>
              </Row>
              {/* candidate table ends */}

              {/* Side bar start */}
              <Row>
                <Col lg={12}>
                  <Sidebar
                    visible={candidateSidebarVisible}
                    position="right"
                    onHide={() => {
                      dispatch(setCandidateSidebarVisible(false))
                      resetCandidateSidebarForm();
                      setFormData(prev => ({ ...prev, ...initialAddressState }))
                      setTempAddressData({ ...initialAddressState })
                      setIsDuplicateEmail(false)
                      setDuplicateCandidateId(null)
                      setEmailError("")
                      setResumeError("")
                    }}
                    className="sidebar"
                  >
                    <div className="sidebar-header">
                      <h3>Create a Candidate</h3>
                      <div className="d-flex align-items-center">
                        <Link to="/candidate-editform">
                          <p className="mb-0 text-white">
                            {" "}
                            <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                          </p>
                        </Link>
                        <Button
                          icon="pi pi-times"
                          className="p-button-text close-btn"
                          onClick={() => {
                            dispatch(setCandidateSidebarVisible(false));
                            resetCandidateSidebarForm();
                            setFormData(prev => ({
                              ...prev,
                              ...initialAddressState,
                            }))
                            setTempAddressData({ ...initialAddressState })
                            setIsDuplicateEmail(false)
                            setDuplicateCandidateId(null)
                            setEmailError("")
                            setResumeError("")
                          }}
                        />
                      </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="card sidebardetails">
                        <Row className="mb-3">
                          <Col lg={6}>
                            <label className="mb-0">
                              First Name <span className="text-danger">*</span>
                            </label>
                            <InputText
                              {...register("firstname", {
                                required: "First name is required *",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z-\s&,]+$/,
                                  message:
                                    "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Minimum 100 Characters Are Allowed",
                                },
                                minLength: {
                                  value: 1,
                                  message: "Minimum 1 Characters Are Allowed",
                                },
                              })}
                              onKeyUp={() => {
                                trigger("firstname")
                              }}
                            />
                            {errors.firstname && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.firstname.message}
                              </small>
                            )}
                          </Col>
                          {/* <Col lg={6}>
                          <label htmlFor="middle_name" className="mb-0">
                            Middle Name
                          </label>
                          <InputText
                            id="middle_name"
                            name="middle_name"
                            {...register("middle_name", {
                              //  required: "Middle name is required",
                              pattern: {
                                value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                message:
                                  "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                              },
                               maxLength: {
                                value: 100,
                                message: "Minimum 100 Characters Are Allowed",
                              },
                              minLength: {
                                value: 1,
                                message: "Minimum 1 Characters Are Allowed",
                              },
                            })}
                            onKeyUp={() => { trigger("middle_name") }}
                          />
                          {errors.middle_name && (<small id='personalEmailHelp' className='form-text text-danger'>{errors.middle_name.message}</small>)}
                        </Col> */}
                          <Col lg={6}>
                            <label htmlFor="lastName" className="mb-0">
                              Last Name
                            </label>
                            <InputText
                              id="lastName"
                              name="lastName"
                              {...register("lastname", {
                                // required: "Last name is required",
                                pattern: {
                                  value: /^[A-Za-z][A-Za-z-\s&]+$/,
                                  message:
                                    "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Minimum 100 Characters Are Allowed",
                                },
                                minLength: {
                                  value: 1,
                                  message: "Minimum 1 Characters Are Allowed",
                                },
                              })}
                              onKeyUp={() => {
                                trigger("lastname")
                              }}
                            />
                            {errors.lastname && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.lastname.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <label htmlFor="email" className="mb-0">
                              Email <span className="text-danger">*</span>
                            </label>
                            {/* sais code */}
                            <InputText
  id="email"
  name="email"
  inputRef={emailInputRef}
  {...register("personal_email", {
    required: "Email is required *",
    pattern: emailValidation,
    onChange: async event => {
      const value = event.target.value.toLowerCase();
      setValue("personal_email", value);

      // Debounce logic starts here
      if (emailDebounceRef.current) {
        clearTimeout(emailDebounceRef.current);
      }
      emailDebounceRef.current = setTimeout(async () => {
        if (value) {
          try {
            const response = await axios.post(
              "/api/v1/candidates/check-email/",
              { email: value }
            );
            if (response.data.duplicate) {
              setIsDuplicateEmail(true);
              setDuplicateCandidateId(response.data.candidate_id);
              setEmailError("Candidate with this email already exists.");
            } else {
              setIsDuplicateEmail(false);
              setDuplicateCandidateId(null);
              setEmailError("");
            }
          } catch (err) {
            setIsDuplicateEmail(false);
            setDuplicateCandidateId(null);
            setEmailError("Failed to check duplicate email.");
          }
        } else {
          setIsDuplicateEmail(false);
          setDuplicateCandidateId(null);
          setEmailError("");
        }
      }, 700); // 700ms debounce
      // Debounce logic ends here
    },
  })}
/>
                            {(isDuplicateEmail && duplicateCandidateId) ||
                            emailError ? (
                              <div className="mt-2">
                                <small className="form-text text-danger">
                                  {emailError ||
                                    "Candidate with this email already exists."}
                                </small>
                                {isDuplicateEmail && duplicateCandidateId && (
                                  <Button
                                    className="btn btn-warning ms-2"
                                    onClick={() =>{
                                      dispatch(setCandidateSidebarVisible(false)); // Hide sidebar
                                      navigate(
                                        `/candidate-editform?candidate_id=${duplicateCandidateId}`
                                      )
                                    }}
                                  >
                                    Edit Candidate
                                  </Button>
                                )}
                              </div>
                            ) : null}

                            {errors.personal_email && (
                              <small
                                id="personalEmailHelp"
                                className="form-text text-danger"
                              >
                                {errors.personal_email.message}
                              </small>
                            )}
                          </Col>

                          <Col lg={6}>
                            <label htmlFor="phoneNumber" className="mb-0">
                              Phone Number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <InputText
                              id="phoneNumber"
                              name="phoneNumber"
                              {...register("phone", {
                                required: "Phone number is required *",
                                pattern: onlyNumbers,
                                minLength: MinLengthValidation(10),
                                maxLength: MaxLengthValidation(14),
                                validate: {
                                  notAllZeros: value =>
                                    !/^0+$/.test(value) ||
                                    "Mobile number cannot be all zeros",
                                  exactLength: value =>
                                    value.length === 10 ||
                                    "Mobile number must be exactly 10 digits",
                                },
                              })}
                              onKeyUp={e => {
                                trigger("phone")
                              }}
                            />{" "}
                            {errors.phone && (
                              <small
                                id="phoneNoHelp"
                                className="form-text text-danger"
                              >
                                {errors.phone.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <label htmlFor="jobTitle" className="mb-0">
                              Job Title
                            </label>
                            <InputText
                              id="jobTitle"
                              name="jobTitle"
                              {...register("jobtitle", {
                                //   required: "This field is required",
                                pattern: onlyAlphabetsandSpaces,
                              })}
                              onKeyUp={() => {
                                trigger("jobtitle")
                              }}
                            />
                            {errors.jobtitle && (
                              <small
                                id="emailHelp"
                                className="form-text text-danger"
                              >
                                {errors.jobtitle.message}
                              </small>
                            )}
                          </Col>
                          <Col lg={6}>
  <label htmlFor="company" className="mb-0">
    Company
  </label>
  <Controller
    name="Company"
    control={control}
    render={({ field }) => (
      <InputText
        {...field}
        value={field.value || ""}
        placeholder="Enter Company Name"
        className="w-full border border-gray-300 rounded-md bg-white"
        onChange={e => field.onChange(e.target.value)}
      />
    )}
  />
  {errors.Company && (
    <small id="emailHelp" className="form-text text-danger">
      {errors.Company.message}
    </small>
  )}
</Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={6}>
                            <label htmlFor="source" className="mb-0">
                              Source <span className="text-danger">*</span>
                            </label>
                            <Dropdown
                              id="source"
                              value={formData.source}
                              options={resumeSourceOptions}
                              placeholder="Select Source"
                              className={`w-full border border-gray-300 rounded-md bg-white ${formErrors.source ? 'p-invalid' : ''}`}
                              onChange={e => handleInputChange('source', e.value)}
                              filter
                              showClear={!!formData.source}
                              optionLabel="label"
                              optionValue="value"
                            />
                            {formErrors.source && (
                              <small className="text-danger d-block mt-1">
                                {formErrors.source}
                              </small>
                            )}
                          </Col>
                          {/* <Col lg={6}>
                            <label htmlFor="stage" className="mb-0">
                              Stage <span className="text-danger">*</span>
                            </label>
                            <Dropdown
                              id="stage"
                              value={formData.stage}
                              options={stages.map(stage => ({
                                label: stage.charAt(0).toUpperCase() + stage.slice(1),
                                value: stage
                              }))}
                              placeholder="Select Stage"
                              className={`w-full border border-gray-300 rounded-md bg-white ${formErrors.stage ? 'p-invalid' : ''}`}
                              onChange={e => handleInputChange('stage', e.value)}
                              filter
                              showClear={!!formData.stage}
                              optionLabel="label"
                              optionValue="value"
                            />
                            {formErrors.stage && (
                              <small className="text-danger d-block mt-1">
                                {formErrors.stage}
                              </small>
                            )}
                          </Col> */}
                          <Col lg={6}>
                            <label htmlFor="primarySkills" className="mb-0">
                              Primary Skills
                            </label>
                            {/* <Dropdown
                            id="jobLocation"
                            value={primarySkillsview}
                            onChange={(e) => setprimarySkillsview(e.value)}
                            options={primarySkillsget}
                            optionLabel="name"
                            optionValue="id"
                            filter
                            filterPlaceholder="Search Location"
                            className="w-full activejobdrop"
                            placeholder="Enter job location..."Relocation
                          /> */}
                            <MultiSelect
                              id="primarySkills"
                              value={primarySkillsview}
                              onChange={e => setprimarySkillsview(e.value)} // e.value will be an array of selected IDs
                              options={primarySkillsget}
                              optionLabel="name"
                              optionValue="id"
                              filter
                              display="chip" // optional: shows chips for selected values
                              className="w-full activejobdrop"
                              placeholder="Select primary skills..."
                            />
                          </Col>
                        </Row>
                        
                        <Row className="mb-3">
                          {/* <Col lg={6} className="mb-2">
                          <label htmlFor="country" className="mb-0">
                            Country
                          </label>
                          <Dropdown
                            id="country"
                            value={selectedCountry}
                            onChange={(e) => { setSelectedCountry(e.value) }}
                            options={addCountry}
                            optionLabel="name"
                            filter
                            filterPlaceholder="Search Country"
                            className="w-full activejobdrop"
                            placeholder="Enter Country details..."
                          />
                        </Col>
                        <Col lg={6} className="mb-2">
                          <label htmlFor="state" className="mb-0">
                            State
                          </label>
                          <Dropdown
                            id="state"
                            value={selectedState}
                            onChange={(e) => { setSelectedState(e.value) }}
                            options={addStates}
                            optionLabel="name"
                            filter
                            filterPlaceholder="Search "
                            className="w-full activejobdrop"
                            placeholder="Enter state details..."
                          />
                        </Col> */}
                          {/* <Col lg={6}>
                            <label htmlFor="city" className="mb-0">
                              City
                            </label>
                            <Dropdown
                              id="city"
                              value={selectedCity}
                              onChange={e => {
                                setSelectedCity(e.value)
                              }}
                              optionValue="city_id"
                              options={addCities}
                              optionLabel="name"
                              filter
                              filterPlaceholder="Search City"
                              className="w-full activejobdrop"
                              placeholder="Enter city details..."
                            />
                          </Col> */}

                          <Col lg={12}>
                            <label
                              htmlFor="availabilityDate"
                              className="mb-0 avbdate"
                            >
                              Availability Date
                            </label>
                            <input
                              type="date"
                              id="availabilityDate"
                              name="availabilityDate"
                              className="form-control"
                              min={new Date().toISOString().split("T")[0]}
                              // max={MaxDateOfBith}
                              {...register("Availability", {})}
                            />
                            {errors.Availability && (
                              <small
                                id="emailHelp"
                                className="form-text text-danger"
                              >
                                {errors.Availability.message}
                              </small>
                            )}
                          </Col>
                        </Row>
                        {/* sai's code */}
                        <Row className="mb-3">
                          <Col lg={12}>
                            <div
                              className="p-field companie-add"
                              style={{ position: "relative" }}
                            >
                              <label htmlFor="address">Address</label>
                              <InputTextarea
                                id="address"
                                value={formData.address}
                                readOnly
                                style={{ paddingRight: "2rem" }}
                                rows={3}
                                cols={30}
                                className={
                                  formErrors.address
                                    ? "p-invalid w-full"
                                    : "w-full"
                                }
                              />
                              <i
                                className="pi pi-pencil"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "70%",
                                  transform: "translateY(-50%)",
                                  color: "#6c757d",
                                  cursor: "pointer",
                                }}
                                onClick={openAddressDialog}
                              />
                              <Dialog
                                header="Edit Address"
                                className="address-popup"
                                visible={visible}
                                onHide={handleAddressDialogCancel}
                                style={{ width: "30vw" }}
                                breakpoints={{
                                  "960px": "75vw",
                                  "641px": "100vw",
                                }}
                                footer={
                                  <div>
                                    <Button
                                      label="OK"
                                      icon="pi pi-check"
                                      onClick={handleAddressDialogOk}
                                      className="p-button-primary"
                                    />
                                  </div>
                                }
                              >
                                <div className="card sidebardetails">
                                  <form>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="street_address">
                                            Street 1
                                          </label>
                                          <InputText
                                            id="street_address"
                                            value={
                                              tempAddressData.street_address
                                            }
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "street_address",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter Street 1"
                                            className={
                                              formErrors.street_address
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                          />
                                          {formErrors.street_address && (
                                            <small className="p-error">
                                              {formErrors.street_address}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="street_address_line_2">
                                            Street 2
                                          </label>
                                          <InputText
                                            id="street_address_line_2"
                                            value={
                                              tempAddressData.street_address_line_2
                                            }
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "street_address_line_2",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter Street 2 (Optional)"
                                            className={
                                              formErrors.street_address_line_2
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                          />
                                          {formErrors.street_address_line_2 && (
                                            <small className="p-error">
                                              {formErrors.street_address_line_2}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="country">
                                            Country
                                          </label>
                                          <Dropdown
                                            id="country"
                                            value={tempAddressData.country}
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "country",
                                                e.value
                                              )
                                            }
                                            options={countries}
                                            optionLabel="name"
                                            optionValue={option => option}
                                            filter
                                            filterPlaceholder="Search Country"
                                            className={
                                              formErrors.country
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                            placeholder="Select Country"
                                            disabled={!countries.length}
                                          />
                                          {formErrors.country && (
                                            <small className="p-error">
                                              {formErrors.country}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="state">State</label>
                                          <Dropdown
                                            id="state"
                                            value={tempAddressData.state}
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "state",
                                                e.value
                                              )
                                            }
                                            options={states}
                                            optionLabel="name"
                                            optionValue={option => option}
                                            filter
                                            filterPlaceholder="Search State"
                                            className={
                                              formErrors.state
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                            placeholder="Select State"
                                            disabled={
                                              !tempAddressData.country ||
                                              !states.length
                                            }
                                          />
                                          {formErrors.state && (
                                            <small className="p-error">
                                              {formErrors.state}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="city">City</label>
                                          <Dropdown
                                            id="city"
                                            value={tempAddressData.city}
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "city",
                                                e.value
                                              )
                                            }
                                            options={cities}
                                            optionLabel="name"
                                            optionValue={option => option}
                                            filter
                                            filterPlaceholder="Search City"
                                            className={
                                              formErrors.city
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                            placeholder="Select City"
                                            disabled={
                                              !tempAddressData.state ||
                                              !cities.length
                                            }
                                          />
                                          {formErrors.city && (
                                            <small className="p-error">
                                              {formErrors.city}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <div className="p-field">
                                          <label htmlFor="pincode">
                                            Postal Code
                                          </label>
                                          <InputText
                                            id="pincode"
                                            value={tempAddressData.pincode}
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "pincode",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter Postal Code"
                                            className={
                                              formErrors.pincode
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                          />
                                          {formErrors.pincode && (
                                            <small className="p-error">
                                              {formErrors.pincode}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col lg={12}>
                                        <div className="pist-field">
                                          <label htmlFor="label">Label</label>
                                          <Dropdown
                                            id="label"
                                            value={tempAddressData.label}
                                            onChange={e =>
                                              handleTempAddressChange(
                                                "label",
                                                e.value
                                              )
                                            }
                                            options={addressLabels}
                                            optionLabel="label"
                                            optionValue="value"
                                            placeholder="Select Label"
                                            className={
                                              formErrors.label
                                                ? "p-invalid w-full activejobdrop"
                                                : "w-full activejobdrop"
                                            }
                                          />
                                          {formErrors.label && (
                                            <small className="p-error">
                                              {formErrors.label}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  </form>
                                </div>
                              </Dialog>
                            </div>
                          </Col>
                        </Row>

                        {/* <Row className="mb-3">
                        <Col lg={12}>
                          <label
                            htmlFor="availabilityDate"
                            className="mb-0 avbdate"
                          >
                            Resume Attachment
                          </label>

                          <input
                            type="file"
                            accept="image/jpg,image/jpeg,image/png,application/pdf"
                            className="form-control addEmp_ProfilePhoto"
                            id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                            onChange={handleFileChange}
                          />
                          {error && (
                            <small className="text-danger">{error}</small>
                          )}
                          <small className="text-muted">
                            Eg: (jpeg,png,pdf,jpg)
                          </small>
                        </Col>
                      </Row> */}
                        <Row className="mb-3">
                          <Col lg={12}>
                            <label
                              htmlFor="availabilityDate"
                              className="mb-0 avbdate"
                            >
                              Resume Attachment
                            </label>
                            <input
                              type="file"
                              accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              className="form-control addEmp_ProfilePhoto"
                              id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                              onChange={handleFileChange}
                            />
                            {resumeError && (
                              <small className="text-danger">
                                {resumeError}
                              </small>
                            )}
                            <small className="text-muted">
                              Eg: (jpeg, png, pdf, jpg, doc, docx) upto 5MB
                            </small>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="company">Categories</label>
                              <TreeSelect
                                value={selectedCategoryNode}
                                options={categoryNodes}
                                onChange={e => setSelectedCategoryNode(e.value)}
                                className="w-full"
                                placeholder="Select Category"
                                filter
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="company">Group</label>
                              <TreeSelect
                                value={selectedGroupNode}
                                options={groupNodes}
                                onChange={e => setSelectedGroupNode(e.value)}
                                className="w-full"
                                placeholder="Select Group"
                                filter
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="mb-2 align-items-end">
                          <Col lg={6}>
                            <div className="p-field">
                              <label htmlFor="jobType">UserIDs</label>
                              <InputText
                                value={uniqueUserId}
                                disabled
                                placeholder="Select a User ID"
                                className="w-full activejobdrop"
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <Row>
                              <Col lg={6}>
                                <div className="mb-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <Controller
                                      name="relocation"
                                      control={control}
                                      render={({ field }) => (
                                        <Checkbox
                                          inputId="relocation"
                                          onChange={e =>
                                            field.onChange(e.checked)
                                          }
                                          checked={field.value}
                                          onBlur={field.onBlur}
                                        />
                                      )}
                                    />
                                    <label
                                      htmlFor="relocation"
                                      className="mb-0"
                                    >
                                      Relocation
                                    </label>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="mb-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <Controller
                                      name="private"
                                      control={control}
                                      render={({ field }) => (
                                        <>
                                          <Checkbox
                                            inputId="private"
                                            inputRef={field.ref}
                                            checked={field.value}
                                            onChange={e => {
                                              field.onChange(e.checked)
                                              trigger("private")
                                            }}
                                          />
                                          <label
                                            htmlFor="private"
                                            className="mb-0"
                                          >
                                            Private
                                          </label>
                                        </>
                                      )}
                                    />
                                  </div>
                                </div>
                              </Col>

                              {/* <Col lg={6}>
                                <div className="p-field">
                                  <input
                                    type="checkbox"
                                    className="me-2"
                                    {...register("private", {})}
                                    onKeyUp={() => {
                                      trigger("private")
                                    }}
                                  />
                                  <label htmlFor="jobType">Private</label>
                                </div>
                              </Col> */}
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          {loading && (
                            <div className="flex justify-content-center align-items-center mt-3">
                              <ProgressSpinner />
                            </div>
                          )}
                        </Row>
                        <div className="buttons float-end">
                          <Button
                            type="submit"
                            color="primary"
                            className="btn btn-primary me-2 sidebarbtn"
                            // onClick={() => setVisibleRight(false)}
                            disabled={loading}
                          >
                            {loading ? "Saving..." : "Create"}
                          </Button>
                          <Button
                            color="primary"
                            className="btn btn-primary  outlinebtn"
                            // onClick={() => { reset(); setVisibleRight(false) }}
                            onClick={handleCanacelCreateCandidate}
                            disabled={loading || disable}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Sidebar>
                </Col>
              </Row>
              {/* Side bar end */}
            </div>
          </Container>
        )}

        <Modal
          size="md"
          show={showConfirmationDelete}
          onHide={handleDeleteClose}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Delete</h1>
          </Modal.Header>
          <div className="text-center m-3 text-danger"> </div>
          <h4 className="text-center">Are you sure you want to delete ?</h4>
          <div className="text-center m-3">
            <Button className="btn btn-primary m-1" onClick={handleDeleteClose}>
              Cancel
            </Button>
            <button className="btn btn-danger m-1" onClick={deleteCandidate}>
              Delete
            </button>
          </div>
        </Modal>
        <Modal
          size="md"
          show={successAlert}
          onHide={() => setSuccessAlert(false)}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Success</h1>
          </Modal.Header>
          <div className="text-center m-3"> </div>
          <h4 className="text-center">Delete Successfully</h4>
          <div className="text-center m-3">
            <button
              className="btn btn-primary"
              onClick={() => setSuccessAlert(false)}
            >
              {" "}
              OK{" "}
            </button>
          </div>
        </Modal>
        <Modal
          size="md"
          show={successAlertinter}
          onHide={() => setsuccessAlertinter(false)}
          className="text-center"
        >
          <Modal.Header closeButton>
            <h1 className="modal-title fs-5 "> Success</h1>
          </Modal.Header>
          <div className="text-center m-3"> </div>
          <h4 className="text-center">Successfully</h4>
          <div className="text-center m-3">
            <button
              className="btn btn-primary"
              onClick={() => setsuccessAlertinter(false)}
            >
              {" "}
              OK{" "}
            </button>
          </div>
        </Modal>

        {/* view employee start */}
        <Row>
          <Col lg={12}>
            <Sidebar
              visible={visibleViewRight}
              position="right"
              onHide={() => setVisibleViewRight(false)}
              className="view-form-sidebar"
            >
              <div className="sidebar-header">
                <h3 className="head">
                  <i className="pi pi-users"></i> Candidate -{" "}
                  {selectedCustomers[0]?.first_name ||
                  selectedCustomers[0]?.last_name
                    ? (selectedCustomers[0]?.first_name || "") +
                      " " +
                      (selectedCustomers[0]?.last_name || "")
                    : (cpFirstName || "") + " " + (cpLastName || "")}
                </h3>
                <div className="d-flex align-items-center">
                  <Link to={`/candidate-editform?candidate_id=${candId}`}>
                    <p className="mb-0 text-white">
                      {" "}
                      <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                    </p>
                  </Link>
                  <Button
                    icon="pi pi-times"
                    className="p-button-text close-btn"
                    onClick={() => setVisibleViewRight(false)}
                  />
                </div>
              </div>
              <TabView className="mt-4">
                <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                  <Row>
                    <Col lg={12}>
                      <Accordion activeIndex={0}>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              <span className="white-space-nowrap">
                                PROFILE INFORMATION
                              </span>
                              <Badge value="-" className="ml-auto" />
                            </span>
                          }
                        >
                          <Row className="mb-2">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="fullName" className="block">
                                  First Name
                                </label>
                                <InputText
                                  id="fullName"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("first_name")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="fullName" className="block">
                                  Last Name
                                </label>
                                <InputText
                                  id="last_name"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("last_name")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="work-email" className="block">
                                  Email
                                </label>
                                <InputText
                                  id="work-email"
                                  disabled
                                  type="email"
                                  placeholder=""
                                  className="w-full"
                                  {...registerViewCandidate("email")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="phoneNumber" className="block">
                                  Phone Number
                                </label>
                                <InputText
                                  id="phoneNumber"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("mobile_phone")}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="jobTitle" className="block">
                                  Job Title
                                </label>
                                <InputText
                                  id="job_title"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("job_title")}
                                />
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="company">Company</label>
                                <InputText
                                  id="company"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("current_company")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="company">Primary Skills</label>
                                <InputText
                                  id="company"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("primary_skills")}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2 align-items-end">
                            <Col lg={4}>
                              <div className="p-field d-flex flex-column">
                                <label htmlFor="city">City</label>
                                <Dropdown
                                  value={selectedCity}
                                  onChange={e => setSelectedCity(e.value)}
                                  options={cityOptions}
                                  optionLabel="name"
                                  placeholder="select city"
                                  filter
                                  className="bgclr"
                                  disabled
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label
                                  htmlFor="availabilityDate"
                                  className="block"
                                >
                                  Availability Date
                                </label>
                                <Calendar
                                  className="w-100"
                                  id="buttondisplay"
                                  value={availabilityDate1}
                                  placeholder="YYYY-MM-DD"
                                  disabled
                                  onChange={e =>
                                    setAvailabilityDate1(e.target.value)
                                  }
                                  showIcon
                                  icon={() => <i className="pi pi-calendar" />}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="relocation" className="block">
                                  Relocation
                                </label>

                                <input
                                  type="checkbox"
                                  disabled
                                  className="me-2"
                                  {...registerViewCandidate("relocation")}
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2">
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="jobType">Categories</label>
                                <InputText
                                  id="company"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("category")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="jobType">Groups</label>
                                <InputText
                                  id="company"
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                  {...registerViewCandidate("group")}
                                />
                              </div>
                            </Col>
                            <Col lg={4}>
                              <div className="p-field">
                                <label htmlFor="jobType">UserIDs</label>
                                <InputText
                                  id="userIds"
                                  value={uniqueUserId}
                                  disabled
                                  placeholder=""
                                  className="block w-full"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Row className="mb-2"></Row>

                          {/* <Row>
                            <Col lg={12}>
                              <div className="p-field">
                                <label htmlFor="jobType" className="block">
                                  Notes
                                </label>
                                <InputTextarea
                                  // autoResize
                                  value={notes1}
                                  disabled
                                  // onChange={e => setDescription(e.target.value)}
                                  rows={3}
                                  cols={40}
                                  placeholder=""
                                  className="w-full "
                                />
                              </div>
                            </Col>
                          </Row> */}
                        </AccordionTab>
                        <AccordionTab
                          header={
                            <span className="flex align-items-center gap-2 w-full">
                              <span className="white-space-nowrap">
                                DOCUMENTS
                              </span>
                              <Badge value="-" className="ml-auto" />
                            </span>
                          }
                        >
                          <Row>
                            <Col lg={12}>
                              <div className="doc-table">
                                <TreeTable
                                  value={documents}
                                  tableStyle={{ minWidth: "50rem" }}
                                  dataKey="key"
                                >
                                  <Column
                                    field="certificate_name"
                                    header="Document Type"
                                    body={rowData =>
                                      editableTemplate(
                                        rowData,
                                        "certificate_name"
                                      )
                                    }
                                  />
                                  <Column
                                    field="docSubject"
                                    header="Document Subject"
                                    body={rowData =>
                                      editableTemplate(rowData, "docSubject")
                                    }
                                  />
                                  <Column
                                    field="created_at"
                                    header="Applied Date & Time"
                                    // body={rowData =>
                                    //   editableTemplate(rowData, "created_at")
                                    // }
                                  />
                                  <Column
                                    field="attachments"
                                    header="Attachments"
                                    body={attachmentBodyTemplate}
                                    style={{ minWidth: "12rem" }}
                                  />
                                  <Column
                                    body={actionTemplate}
                                    header="Actions"
                                  />
                                </TreeTable>
                              </div>
                            </Col>
                          </Row>
                        </AccordionTab>
                      </Accordion>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header="Resume" leftIcon="pi pi-file mr-2">
                  <Row>
                    <Col lg={12}>
                      <div>
                        <Accordion activeIndex={[0, 1]} multiple>
                          <AccordionTab header="Resume">
                            {resumeDataforView ? (
                              <>
                                <Row className="resumehead">
                                  <Col lg={12}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex justify-content-between"></div>

                                      <Button
                                        type="submit"
                                        color="primary"
                                        className="btn btn-primary me-2 sidebarbtn"
                                        onClick={() =>
                                          downloadResume(getResumeUrl(resumeDataforView))
                                        }
                                      >
                                        <i class="pi pi-download me-2"></i>
                                        Download Resume
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>

                                <Row
                                  className="resumedetails mt-3"
                                  id="resume-content"
                                >
                                  <Col lg={12}>
                                    <FilePreview 
                                      fileUrl={getResumeUrl(resumeDataforView)} 
                                    />
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <Row
                                className="resumedetails mt-3"
                                id="resume-content"
                              >
                                <Col lg={12}>No Data Available</Col>
                              </Row>
                            )}
                          </AccordionTab>
                          {/* <AccordionTab header="Skill Matrix">
                            <p></p>
                          </AccordionTab> */}
                        </Accordion>
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header="Pipeline" leftIcon="pi pi-cog mr-2">
                  <Row>
                    <Col lg={12}>
                      <div className="pipelinetabs">
                        {stages.length === 0 ? (
                          <p>Loading stages or no stages available...</p>
                        ) : (
                          <TabView
                            scrollable
                            style={{ maxWidth: "1200px", overflow: "hidden" }}
                          >
                            {stages?.map(stage => (
                              <TabPanel
                                key={stage}
                                header={
                                  stage?.charAt(0).toUpperCase() + stage?.slice(1)
                                }
                                rightIcon={
                                  <Badge
                                    value={stageCounts[stage] || 0}
                                    severity="success"
                                    className="ml-2"
                                  />
                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={pipelineData[stage] || []}
                                          tableStyle={{
                                            minWidth: "50rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={5}
                                          rowsPerPageOptions={[5, 10, 25, 50]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={initFilters}
                                          filterDisplay="row"
                                          emptyMessage={`No ${stage} jobs found.`}
                                          selection={selectedJobs[stage] || []}
                                          onSelectionChange={e =>
                                            handleSelectionChange(
                                              stage,
                                              e.value
                                            )
                                          }
                                          // selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          {/* <Column
                                            field="stage"
                                            header="Stage"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by stage"
                                            style={{ minWidth: "12rem" }}
                                          /> */}
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by job ID"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by job title"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="candidate_name"
                                            header="candidate"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by contact"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="hiring_manager_name"
                                            header="Contact"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by contact"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="company_name"
                                            header="Company"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by contact"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by status"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="create_date"
                                            header="Create Date"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by create date"
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="createdBy"
                                            header="Created by Name"
                                            sortable
                                            filter
                                            filterPlaceholder="Search by user ID"
                                            style={{ minWidth: "12rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                            ))}
                          </TabView>
                        )}
                      </div>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header="Activities" leftIcon="pi pi-calendar mr-2">
                  <Row>
                    <Col lg={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          <DataTable
                            responsive
                            showGridlines
                            value={activities}
                            tableStyle={{
                              minWidth: "50rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            paginator
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            filters={activitiesFilters}
                            filterDisplay="row"
                            globalFilterFields={[
                              "type",
                              "sub_type",
                              "date_time",
                              "priority",
                              "subject",
                              "status",
                            ]}
                            emptyMessage="No activities found."
                            selection={selectedActivities}
                            onSelectionChange={e =>
                              setSelectedActivities(e.value)
                            }
                            selectionMode="multiple"
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              field="type"
                              sortable
                              header="Type"
                              frozen
                              filter
                              filterPlaceholder="Search"
                              style={{ minWidth: "12rem" }}
                              editor={textEditor}
                              onCellEditComplete={onCellEditComplete}
                            />
                            <Column
                              field="sub_type"
                              sortable
                              header="Sub-Type"
                              filter
                              filterPlaceholder="Search by sub-type"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="priority"
                              sortable
                              header="Priority"
                              filter
                              filterPlaceholder="Search by priority"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="subject"
                              sortable
                              header="Subject"
                              filter
                              filterPlaceholder="Search by subject"
                              style={{ minWidth: "12rem" }}
                            />
                            <Column
                              field="date_time"
                              sortable
                              header="Event Time"
                              filter
                              filterPlaceholder="Search by event time"
                              style={{ minWidth: "12rem" }}
                              body={rowData =>
                                rowData.date_time
                                  ? moment(rowData.date_time)
                                      .utcOffset("+05:30")
                                      .format("YYYY-MM-DD")
                                  : "N/A"
                              }
                            />

                            <Column
                              field="status"
                              sortable
                              header="Status"
                              filter
                              filterPlaceholder="Search by status"
                              style={{ minWidth: "12rem" }}
                            />
                          </DataTable>
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header="History" leftIcon="pi pi-clock mr-2" className="nav-items">
                  <Row>
                    <Col lg={12} sm={12}>
                      <section className="job-datatable-section">
                        <div className="card1 mt-3 mb-4 actjobsumtable">
                          <DataTable
                            responsive
                            showGridlines
                            value={history}
                            tableStyle={{
                              minWidth: "50rem",
                              borderRadius: "8px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            onFilter={e => setHistoryFilters(e.filters)}
                            paginator
                            rows={5}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            filters={historyFilters}
                            filterDisplay="row"
                            globalFilterFields={[
                              "type",
                              "sub_type",
                              "priority",
                              "subject",
                              "date_time",
                              "user_id",
                            ]}
                            emptyMessage="No history found."
                            selection={selectedHistory}
                            onSelectionChange={e => setSelectedHistory(e.value)}
                            selectionMode="multiple"
                            resizableColumns
                            columnResizeMode="expand"
                          >
                            <Column
                              field="type"
                              header="Type"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />

                            <Column
                              field="subject"
                              header="Subject"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                            <Column
                              field="datetime"
                              header="Date and Time"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                              body={rowData => formatDate(rowData.datetime)}
                            />
                            <Column
                              field="user_id"
                              header="User ID"
                              sortable
                              filter
                              style={{ minWidth: "10rem" }}
                            />
                          </DataTable>
                        </div>
                      </section>
                    </Col>
                  </Row>
                </TabPanel>
                <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2" className="nav-items">
                  <Row>
                    <Col lg={12}>
                      <div className="d-flex justify-content-end">
                        <Button
                          type="button"
                          label="Add Notes"
                          icon="pi pi-plus"
                          className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                          onClick={handleAddNotes}
                        />
                      </div>
                    </Col>
                  </Row>

                  {isEditorVisible && (
                    <Row className="mt-4">
                      <Col lg={12}>
                        <Editor
                          value={editorContent}
                          onTextChange={e => setEditorContent(e.htmlValue)}
                          // onTextChange={handleTextChange}
                          style={{ height: "200px" }}
                          placeholder="Enter your notes here..."
                        />
                        <div className="d-flex justify-content-end mt-2">
                          <Button
                            type="button"
                            label="Save"
                            icon="pi pi-save"
                            className="btn btn-success me-2"
                            onClick={handleSaveNotes}
                          />
                          <Button
                            color="primary"
                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                            onClick={handleCancelNotes}
                          >
                            <i className="pi pi-times me-1"></i>
                            Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-4 notes">
                    <Col lg={12}>
                      {candidateNotes.length > 0 && (
                        <Card className="pt-0 pb-0">
                          {candidateNotes?.map((note, index) => (
                            <div key={index}>
                              <div className="d-flex mt-0">
                                <strong className="text-muted me-4">
                                  Note: {note?.created_by_name}
                                </strong>
                                <strong className="text-muted">
                                  {formatDate(note?.created_at)}
                                </strong>
                              </div>
                              <div className="d-flex justify-content-between mt-2 mb-0">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: note?.notes,
                                  }}
                                />
                                <div>
                                  <Button
                                    icon="pi pi-pencil"
                                    className="btn btn-warning editbtn p-0"
                                    onClick={() => handleEditNote(note)}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    className="btn btn-danger deletebtn"
                                    onClick={() => handleDeleteNote(note)}
                                  />
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}
                        </Card>
                      )}
                    </Col>
                  </Row>
                </TabPanel>
              </TabView>
            </Sidebar>
          </Col>
        </Row>

        {/* view employee end */}

        {/* Interview schedule call start */}
        <Dialog
          header="Appointment"
          visible={scheduleCommonPopup}
          className="interview-popup"
          style={{ width: "50vw" }}
          // onHide={() => { if (!interviewpop) return; SetInterviewpop(false); }}
          onHide={closeSchedulePopup}
        >
          <form onSubmit={onSubmitSchedule}>
            <p className="bg-form">
              <div className="mb-4">
                <Row className="mb-2">
                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="interview">
                        Type <span className="text-danger">*</span>
                      </label>
                      <InputText
                        disabled
                        // value={intertype3}
                        value={selectedSchedule?.name}

                        // onChange={e => setintertype1(e.target.value)}
                      />
                      {/* <Dropdown 
                                                            // disabled
                                                            value={intertype}
                                                            onChange={(e) => setintertype(e.target.value)}
                                                            options={interviewdroptype}
                                                            className="w-full search-option" /> */}
                    </div>
                  </Col>

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="integer" className=" block">
                        Sub-Type <span className="text-danger">*</span>
                      </label>
                      <Dropdown
                        value={scheduleSubtype}
                          onChange={e => {
    setScheduleSubtype(e.value);
    setScheduleFormErrors(prev => ({
      ...prev,
      event_sub_type: "" // Clear error when value is selected
    }));
  }}
                        options={subtypeCall}
                        optionLabel="name"
                        placeholder="Subtype"
                        className="w-full search-option"
                      />
                      {scheduleFormErrors.event_sub_type && (
                        <small className="p-error">
                          {scheduleFormErrors.event_sub_type}
                        </small>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Row>
                    <Col xl={6}>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <div className="p-field flex-auto">
                            <label htmlFor="startDate" className="block">
                              Start date <span className="text-danger">*</span>
                            </label>
                            <Calendar
                              id="startDate"
                              value={scheduleStartDate}
                              onChange={e => setScheduleStartdate(e.value)}
                              showIcon
                              minDate={today}
                              dateFormat="yy-mm-dd"
                              icon={() => <i className="pi pi-calendar" />}
                            />
                            {scheduleFormErrors.start_date && (
                              <small className="p-error">
                                {scheduleFormErrors.start_date}
                              </small>
                            )}
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="p-field flex-auto">
                            <label htmlFor="startTime" className="block">
                              Time <span className="text-danger">*</span>
                            </label>
                            <Calendar
                              id="startTime"
                              value={scheduleStartTime}
                              onChange={e => setScheduleStarttime(e.value)}
                              showIcon
                              timeOnly
                              icon={() => <i className="pi pi-clock" />}
                            />
                            {scheduleFormErrors.start_time && (
                              <small className="p-error">
                                {scheduleFormErrors.start_time}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xl={6}>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <div className="flex-auto">
                            <label htmlFor="endDate" className="block">
                              End date <span className="text-danger">*</span>
                            </label>
                            <Calendar
                              id="endDate"
                              value={scheduleEndDate}
                              onChange={e => setScheduleEndDate(e.value)}
                              showIcon
                              minDate={scheduleStartDate || today}
                              dateFormat="yy-mm-dd"
                              icon={() => <i className="pi pi-calendar" />}
                            />
                            {scheduleFormErrors.end_date && (
                              <small className="p-error">
                                {scheduleFormErrors.end_date}
                              </small>
                            )}
                          </div>
                        </Col>

                        <Col xl={6}>
                          <div className="flex-auto">
                            <label htmlFor="endTime" className="block">
                              Time <span className="text-danger">*</span>
                            </label>
                            <Calendar
                              id="endTime"
                              value={scheduleEndTime}
                              onChange={e => setScheduleEndTime(e.value)}
                              showIcon
                              timeOnly
                              icon={() => <i className="pi pi-clock" />}
                            />
                            {scheduleFormErrors.end_time && (
                              <small className="p-error">
                                {scheduleFormErrors.end_time}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Row>
              </div>

              <div className="mb-4">
                <Row className="mb-2">
                  {/* <Col xl={6}>
                    <div className="flex flex-column">
                      <label For="Priority">Job Status</label>
                      <Dropdown
                        value={subtypeget}
                        onChange={e => setsubtypeget(e.value)}
                        options={jobStatusDrop}
                        optionLabel="name"
                        placeholder="Select a Status"
                        className="w-full search-option"
                      />
                    </div>

                  </Col> */}

                  <LinkContactsPopup
                    onSelectedJobsChange={jobs => {
                      // sais code
  setSelectedScheduleJobs(jobs);
  setScheduleFormErrors(prev => ({
    ...prev,
    job_id: "" // Clear error when jobs selected
  }));
}}
                    errorJob={scheduleFormErrors.job_id}
                    // sais code
                    setSelectedScheduleContacts={contacts => {
  setSelectedScheduleContacts(contacts);
  setScheduleFormErrors(prev => ({
    ...prev,
    contacts: "" // Clear error when contacts selected
  }));
}}
                    errorContact={scheduleFormErrors.contacts}
                    jobLabel={
                      <span>
                        Jobs
                      </span>
                    }
                  />
                </Row>

                <Row className="mb-2">
                  {selectedCustomers?.length > 0 ? (
                    <Col lg={6}>
                      <div className="field">
                        <label htmlFor="job" style={{ marginBottom: "4px" }}>
                          Candidates
                        </label>
                        <InputText
                          disabled
                          className="w-full"
                          value={selectedCustomers?.map(
                              candidate =>
                                `${candidate?.first_name} ${
                                  candidate?.last_name ? candidate?.last_name : ""
                                }`
                            )
                            .join(" | ")}
                        />
                      </div>
                    </Col>
                  ) : (
                    <LinkCandidate
                      onSelectedCandidatesChange={candidates =>
                        setSelectedScheduleCandidates(candidates)
                      }
                      error={scheduleFormErrors.candidates}
                      label={
                        <span>
                          Candidate
                        </span>
                      }
                    />
                  )}

                  <Col xl={6}>
                    <div className="p-field flex flex-column">
                      <label htmlFor="username">Subject</label>
                      <InputText
                        placeholder="Subject"
                        value={scheduleSubject}
                        onChange={e => setScheduleSubject(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mb-2 mt-3">
                  <Col xl={12}>
                    <div className="">
                      <InputTextarea
                        className="w-full"
                        value={popTextares}
                        onChange={e => setPopTextares(e.target.value)}
                        placeholder="Interview Test"
                        rows={3}
                        cols={20}
                      />
                      {/* {scheduleFormErrors.body && (
                            <small className="p-error">{scheduleFormErrors.body}</small>
                          )} */}
                    </div>
                  </Col>
                </Row>
              </div>

              <div>
                <Row className="mb-2">
                  <Col lg={6}>
                    <Row>
                      <Col xl={6}>
                        <div className="p-field flex flex-column">
                          <label For="Priority" className=" block">
                            Priority
                          </label>
                          <Dropdown
                            value={schedulePriority}
                            onChange={e => setSchedulePriority(e.value)}
                            options={priorityValue}
                            optionLabel="name"
                            placeholder="Priority"
                            className="w-full search-option"
                          />
                        </div>
                      </Col>
                      <Col xl={6}>
                        <Row className="mt-2">
                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Completed
                              </label>
                            </div>
                          </Col>

                          <Col xl={6}>
                            <div className="d-flex align-items-center mt-4">
                              <Checkbox
                                inputId="checkbox"
                                checked={schedulepopchecked2}
                                onChange={handlePopupCheckbox2}
                              />
                              <label htmlFor="username" className="ms-1 mt-2">
                                Private
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={6}>
                    <label htmlFor="username">User Id's</label>
                    <Chips
                      value={userid}
                      onChange={e => setUserid(e.value)}
                      itemTemplate={customChip}
                      readOnly
                      className="w-full"
                    />
                  </Col>
                </Row>
              </div>
              <Row className="mb-2">
                {(selectedSchedule?.name?.toLowerCase() === "meeting" ||
                  selectedSchedule?.name?.toLowerCase() === "call") && (
                  <>
                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="repeat">
                          Repeat
                        </label>
                        <Dropdown
  id="repeat"
  value={scheduleRepeat}
  onChange={e => {
    setScheduleRepeat(e.value)
    setScheduleFormErrors(prev => ({
      ...prev,
      repeat: "" // Clear error when value is selected
    }))
  }}
  options={repeatOptions}
  optionLabel="label"
  placeholder="Repeat"
  className="w-full search-option"
/>
                        {scheduleFormErrors.repeat && (
                          <small className="p-error">
                            {scheduleFormErrors.repeat}
                          </small>
                        )}
                      </div>
                    </Col>
                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="autofollowup">
                          Auto Followup
                        </label>
                        <Dropdown
  id="autofollowup"
  value={scheduleAutoFollowup}
  onChange={e => {
    setScheduleAutoFollowup(e.value)
    setScheduleFormErrors(prev => ({
      ...prev,
      auto_followup: "" // Clear error when value is selected
    }))
  }}
  options={autoFollowupOptions}
  optionLabel="label"
  placeholder="Auto Followup"
  className="w-full search-option"
/>
                        {scheduleFormErrors.auto_followup && (
                          <small className="p-error">
                            {scheduleFormErrors.auto_followup}
                          </small>
                        )}
                      </div>
                    </Col>
                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="reminder">Reminder</label>
                        <Dropdown
                          id="reminder"
                          value={scheduleReminder}
                          onChange={e => setScheduleReminder(e.value)}
                          options={reminderOptions}
                          optionLabel="label"
                          placeholder="Reminder"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                  </>
                )}
                {selectedSchedule?.name?.toLowerCase() !== "meeting" &&
                  selectedSchedule?.name?.toLowerCase() !== "call" && (
                    <Col xl={4}>
                      <div className="p-field flex flex-column">
                        <label htmlFor="reminder">Reminder</label>
                        <Dropdown
                          id="reminder"
                          value={scheduleReminder}
                          onChange={e => setScheduleReminder(e.value)}
                          options={reminderOptions}
                          optionLabel="label"
                          placeholder="Reminder"
                          className="w-full search-option"
                        />
                      </div>
                    </Col>
                  )}
              </Row>

              <Row className="">
                <Col xl={12}>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light btn btn-primary me-2 btn-main"
                    >
                      <i className="pi pi-save me-1"></i>
                      Save
                    </button>
                    <button
                      color="primary"
                      className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                      onClick={closeSchedulePopup}
                    >
                      <i className="pi pi-times me-1"></i>
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </p>
          </form>
        </Dialog>
        {/* Interview schedule call end */}
      </div>
    </React.Fragment>
  )
})

export default AllActiveemp
